import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'
export type Maybe<T> = T | null
export type InputMaybe<T> = Maybe<T>
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] }
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> }
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> }
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string
  String: string
  Boolean: boolean
  Int: number
  Float: number
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: any
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: any
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any
}

export type AllLibraryMetaCount = {
  all?: Maybe<Scalars['Int']>
}

export type AllLibraryMetaPagination = {
  __typename?: 'AllLibraryMetaPagination'
  currentCount?: Maybe<Scalars['Int']>
  currentPage?: Maybe<Scalars['Int']>
  totalPages?: Maybe<Scalars['Int']>
}

export type AllPharmacyLibraryMeta = {
  __typename?: 'AllPharmacyLibraryMeta'
  count?: Maybe<AllPharmacyLibraryMetaCount>
  pagination?: Maybe<AllLibraryMetaPagination>
}

export type AllPharmacyLibraryMetaCount = AllLibraryMetaCount & {
  __typename?: 'AllPharmacyLibraryMetaCount'
  all?: Maybe<Scalars['Int']>
  casiSession?: Maybe<Scalars['Int']>
  catalogTraining?: Maybe<Scalars['Int']>
  categoryBrochure?: Maybe<Scalars['Int']>
  journalArticle?: Maybe<Scalars['Int']>
  literatureReference?: Maybe<Scalars['Int']>
  patientBrochure?: Maybe<Scalars['Int']>
  patientEducation?: Maybe<Scalars['Int']>
  pharmacyContent?: Maybe<Scalars['Int']>
  priceList?: Maybe<Scalars['Int']>
  privateLabelForm?: Maybe<Scalars['Int']>
  productReferenceChart?: Maybe<Scalars['Int']>
  protocol?: Maybe<Scalars['Int']>
  socialMediaResource?: Maybe<Scalars['Int']>
  techSheet?: Maybe<Scalars['Int']>
  techSheetFrench?: Maybe<Scalars['Int']>
  webinar?: Maybe<Scalars['Int']>
  whitePaper?: Maybe<Scalars['Int']>
}

export type AllPharmacyLibraryResources = {
  __typename?: 'AllPharmacyLibraryResources'
  meta?: Maybe<AllPharmacyLibraryMeta>
  resources?: Maybe<Array<Maybe<PharmacyLibraryResource>>>
}

export type AllProfessionalLibraryMeta = {
  __typename?: 'AllProfessionalLibraryMeta'
  count?: Maybe<AllProfessionalLibraryMetaCount>
  pagination?: Maybe<AllLibraryMetaPagination>
}

export type AllProfessionalLibraryMetaCount = AllLibraryMetaCount & {
  __typename?: 'AllProfessionalLibraryMetaCount'
  all?: Maybe<Scalars['Int']>
  casiSession?: Maybe<Scalars['Int']>
  catalogTraining?: Maybe<Scalars['Int']>
  categoryBrochure?: Maybe<Scalars['Int']>
  journalArticle?: Maybe<Scalars['Int']>
  literatureReference?: Maybe<Scalars['Int']>
  patientBrochure?: Maybe<Scalars['Int']>
  patientEducation?: Maybe<Scalars['Int']>
  priceList?: Maybe<Scalars['Int']>
  privateLabelForm?: Maybe<Scalars['Int']>
  productReferenceChart?: Maybe<Scalars['Int']>
  protocol?: Maybe<Scalars['Int']>
  socialMediaResource?: Maybe<Scalars['Int']>
  techSheet?: Maybe<Scalars['Int']>
  techSheetFrench?: Maybe<Scalars['Int']>
  webinar?: Maybe<Scalars['Int']>
  whitePaper?: Maybe<Scalars['Int']>
}

export type AllProfessionalLibraryResources = {
  __typename?: 'AllProfessionalLibraryResources'
  meta?: Maybe<AllProfessionalLibraryMeta>
  resources?: Maybe<Array<Maybe<ProfessionalLibraryResource>>>
}

export type AllPublicLibraryMeta = {
  __typename?: 'AllPublicLibraryMeta'
  count?: Maybe<AllPublicLibraryMetaCount>
  pagination?: Maybe<AllLibraryMetaPagination>
}

export type AllPublicLibraryMetaCount = AllLibraryMetaCount & {
  __typename?: 'AllPublicLibraryMetaCount'
  all?: Maybe<Scalars['Int']>
  casiSession?: Maybe<Scalars['Int']>
  patientBrochure?: Maybe<Scalars['Int']>
  patientEducation?: Maybe<Scalars['Int']>
}

export type AllPublicLibraryResources = {
  __typename?: 'AllPublicLibraryResources'
  meta?: Maybe<AllPublicLibraryMeta>
  resources?: Maybe<Array<Maybe<PublicLibraryResource>>>
}

export type BackgroundStyles = {
  __typename?: 'BackgroundStyles'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Color used for background that extends from the left and right sides of the page-section to full width (default color is white when not specified). */
  backgroundColor?: Maybe<SiteColor>
}

export type BackgroundStylesFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  backgroundColor?: InputMaybe<SiteColorFilter>
}

export type BackgroundStylesSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type BannerWithArticle = {
  __typename?: 'BannerWithArticle'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  articleContentRaw?: Maybe<Scalars['JSON']>
  articleTitle?: Maybe<Scalars['String']>
  backgroundImage?: Maybe<Image>
  cta?: Maybe<Cta>
  textPosition?: Maybe<Scalars['String']>
  textStyles?: Maybe<TextStyles>
}

export type BannerWithArticleFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  articleTitle?: InputMaybe<StringFilter>
  backgroundImage?: InputMaybe<ImageFilter>
  cta?: InputMaybe<CtaFilter>
  textPosition?: InputMaybe<StringFilter>
  textStyles?: InputMaybe<TextStylesFilter>
}

export type BannerWithArticleOrBannerWithTextOrBasicArticleOrBasicTextSectionOrBlockMenuOrBlockMenuAdditionalShortcutsOrBlockMenuCtaOrButtonBlockSectionOrCarouselOrCtaBlockSectionOrCtaCardSectionOrDispensaryBioOrDispensaryFeaturedProductsOrDispensaryHeroOrFeaturedProductsBannerOrFeaturedProductsCarouselOrGlobalMarketsOrHubSpotFormOrIconAndTextGridOrIconAndTextGridSmallOrImageAndTextSectionOrInstapageOrLeadershipGridOrLibraryOrLogoDividerSectionOrNotificationOrPageHeroOrProductSpotlightOrRegistrationPageOrRichArticleOrScienceTeamGridOrSpacerSectionOrTableSectionOrTermsSectionOrVideoSection =

    | BannerWithArticle
    | BannerWithText
    | BasicArticle
    | BasicTextSection
    | BlockMenu
    | BlockMenuAdditionalShortcuts
    | BlockMenuCta
    | ButtonBlockSection
    | Carousel
    | CtaBlockSection
    | CtaCardSection
    | DispensaryBio
    | DispensaryFeaturedProducts
    | DispensaryHero
    | FeaturedProductsBanner
    | FeaturedProductsCarousel
    | GlobalMarkets
    | HubSpotForm
    | IconAndTextGrid
    | IconAndTextGridSmall
    | ImageAndTextSection
    | Instapage
    | LeadershipGrid
    | Library
    | LogoDividerSection
    | Notification
    | PageHero
    | ProductSpotlight
    | RegistrationPage
    | RichArticle
    | ScienceTeamGrid
    | SpacerSection
    | TableSection
    | TermsSection
    | VideoSection

export type BannerWithArticleSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  articleTitle?: InputMaybe<SortOrder>
  backgroundImage?: InputMaybe<ImageSorting>
  cta?: InputMaybe<CtaSorting>
  textPosition?: InputMaybe<SortOrder>
  textStyles?: InputMaybe<TextStylesSorting>
}

export type BannerWithText = {
  __typename?: 'BannerWithText'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  backgroundStyles?: Maybe<BackgroundStyles>
  contentRaw?: Maybe<Scalars['JSON']>
  contextBasedContent?: Maybe<ContextBasedContent>
  cta?: Maybe<Cta>
  /** Color used for the Call To Action background (default is dark blue when not specified). */
  ctaBackgroundColor?: Maybe<SiteColor>
  /** Color used for the Call To Action text (default is white when not specified). */
  ctaTextColor?: Maybe<SiteColor>
  heroImage?: Maybe<Image>
  heroImageMobile?: Maybe<Image>
  roleBasedContent?: Maybe<RoleBasedContent>
  /** Color used to generate the gradient which is displayed behind the text in mobile/tablet views (default is light gray when not specified). */
  textBackgroundColor?: Maybe<SiteColor>
  textPosition?: Maybe<Scalars['String']>
  textStyles?: Maybe<TextStyles>
}

export type BannerWithTextFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  backgroundStyles?: InputMaybe<BackgroundStylesFilter>
  contextBasedContent?: InputMaybe<ContextBasedContentFilter>
  cta?: InputMaybe<CtaFilter>
  ctaBackgroundColor?: InputMaybe<SiteColorFilter>
  ctaTextColor?: InputMaybe<SiteColorFilter>
  heroImage?: InputMaybe<ImageFilter>
  heroImageMobile?: InputMaybe<ImageFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  textBackgroundColor?: InputMaybe<SiteColorFilter>
  textPosition?: InputMaybe<StringFilter>
  textStyles?: InputMaybe<TextStylesFilter>
}

export type BannerWithTextSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  backgroundStyles?: InputMaybe<BackgroundStylesSorting>
  contextBasedContent?: InputMaybe<ContextBasedContentSorting>
  cta?: InputMaybe<CtaSorting>
  heroImage?: InputMaybe<ImageSorting>
  heroImageMobile?: InputMaybe<ImageSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  textPosition?: InputMaybe<SortOrder>
  textStyles?: InputMaybe<TextStylesSorting>
}

export type BasicArticle = {
  __typename?: 'BasicArticle'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  content?: Maybe<Scalars['String']>
  keepSectionsTogether?: Maybe<Scalars['Boolean']>
  lastModified?: Maybe<Scalars['Date']>
  roleBasedContent?: Maybe<RoleBasedContent>
  title?: Maybe<Scalars['String']>
}

export type BasicArticleFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  content?: InputMaybe<StringFilter>
  keepSectionsTogether?: InputMaybe<BooleanFilter>
  lastModified?: InputMaybe<DateFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  title?: InputMaybe<StringFilter>
}

export type BasicArticleSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  content?: InputMaybe<SortOrder>
  keepSectionsTogether?: InputMaybe<SortOrder>
  lastModified?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  title?: InputMaybe<SortOrder>
}

export type BasicTextSection = {
  __typename?: 'BasicTextSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  bodyRaw?: Maybe<Scalars['JSON']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  textStyles?: Maybe<TextStyles>
}

export type BasicTextSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  textStyles?: InputMaybe<TextStylesFilter>
}

export type BasicTextSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  textStyles?: InputMaybe<TextStylesSorting>
}

export type Block = {
  __typename?: 'Block'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  children?: Maybe<Array<Maybe<Span>>>
  list?: Maybe<Scalars['String']>
  style?: Maybe<Scalars['String']>
}

export type BlockMenu = {
  __typename?: 'BlockMenu'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Section label for assistive technologies */
  ariaLabel?: Maybe<Scalars['String']>
  layout?: Maybe<Scalars['String']>
  links?: Maybe<Array<Maybe<BlockMenuLink>>>
  roleBasedContent?: Maybe<RoleBasedContent>
  /** Section label */
  sectionLabel?: Maybe<Scalars['String']>
}

export type BlockMenuAdditionalShortcuts = {
  __typename?: 'BlockMenuAdditionalShortcuts'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Section label for assistive technologies */
  ariaLabel?: Maybe<Scalars['String']>
  layout?: Maybe<Scalars['String']>
  links?: Maybe<Array<Maybe<BlockMenuLink>>>
}

export type BlockMenuAdditionalShortcutsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  ariaLabel?: InputMaybe<StringFilter>
  layout?: InputMaybe<StringFilter>
}

export type BlockMenuAdditionalShortcutsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  ariaLabel?: InputMaybe<SortOrder>
  layout?: InputMaybe<SortOrder>
}

export type BlockMenuCta = {
  __typename?: 'BlockMenuCta'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Section label for assistive technologies */
  ariaLabel?: Maybe<Scalars['String']>
  backgroundStyles?: Maybe<BackgroundStyles>
  links?: Maybe<Array<Maybe<BlockMenuCtaLink>>>
  roleBasedContent?: Maybe<RoleBasedContent>
  /** Section label */
  sectionLabel?: Maybe<Scalars['String']>
}

export type BlockMenuCtaFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  ariaLabel?: InputMaybe<StringFilter>
  backgroundStyles?: InputMaybe<BackgroundStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  sectionLabel?: InputMaybe<StringFilter>
}

export type BlockMenuCtaLink = {
  __typename?: 'BlockMenuCtaLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  comingSoon?: Maybe<Scalars['Boolean']>
  cta?: Maybe<Cta>
  /** Color used for the Call To Action background (default is dark blue when not specified). */
  ctaBackgroundColor?: Maybe<SiteColor>
  /** Color used for the Call To Action text (default is white when not specified). */
  ctaTextColor?: Maybe<SiteColor>
  description?: Maybe<Scalars['String']>
  /** Color used to generate the gradient background color displayed behind the text, this styling is only applied to Block Menus that render text beneath the image in mobile/tablet view. */
  descriptionBackgroundColor?: Maybe<SiteColor>
  /** Color used for the description (default is dark gray when not specified). */
  descriptionColor?: Maybe<SiteColor>
  desktopImage?: Maybe<Image>
  /** Color used to specify the image background color, should be used with images that have transparent backgrounds (default is transparent when not specified). */
  imageBackgroundColor?: Maybe<SiteColor>
  /** This affects mobile/tablet view only. Default layout has the text block and cta positioned over the left half of the image. */
  layout?: Maybe<Scalars['String']>
  mobileImage?: Maybe<Image>
  tabletImage?: Maybe<Image>
  title?: Maybe<Scalars['String']>
  /** Color used for the header (default is dark blue when not specified). */
  titleColor?: Maybe<SiteColor>
}

export type BlockMenuCtaLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  comingSoon?: InputMaybe<BooleanFilter>
  cta?: InputMaybe<CtaFilter>
  ctaBackgroundColor?: InputMaybe<SiteColorFilter>
  ctaTextColor?: InputMaybe<SiteColorFilter>
  description?: InputMaybe<StringFilter>
  descriptionBackgroundColor?: InputMaybe<SiteColorFilter>
  descriptionColor?: InputMaybe<SiteColorFilter>
  desktopImage?: InputMaybe<ImageFilter>
  imageBackgroundColor?: InputMaybe<SiteColorFilter>
  layout?: InputMaybe<StringFilter>
  mobileImage?: InputMaybe<ImageFilter>
  tabletImage?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
  titleColor?: InputMaybe<SiteColorFilter>
}

export type BlockMenuCtaLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  comingSoon?: InputMaybe<SortOrder>
  cta?: InputMaybe<CtaSorting>
  description?: InputMaybe<SortOrder>
  desktopImage?: InputMaybe<ImageSorting>
  layout?: InputMaybe<SortOrder>
  mobileImage?: InputMaybe<ImageSorting>
  tabletImage?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type BlockMenuCtaSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  ariaLabel?: InputMaybe<SortOrder>
  backgroundStyles?: InputMaybe<BackgroundStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  sectionLabel?: InputMaybe<SortOrder>
}

export type BlockMenuFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  ariaLabel?: InputMaybe<StringFilter>
  layout?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  sectionLabel?: InputMaybe<StringFilter>
}

export type BlockMenuLink = {
  __typename?: 'BlockMenuLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  comingSoon?: Maybe<Scalars['Boolean']>
  description?: Maybe<Scalars['String']>
  image?: Maybe<Image>
  link?: Maybe<Link>
  title?: Maybe<Scalars['String']>
  wideImage?: Maybe<Image>
}

export type BlockMenuLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  comingSoon?: InputMaybe<BooleanFilter>
  description?: InputMaybe<StringFilter>
  image?: InputMaybe<ImageFilter>
  link?: InputMaybe<LinkFilter>
  title?: InputMaybe<StringFilter>
  wideImage?: InputMaybe<ImageFilter>
}

export type BlockMenuLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  comingSoon?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  image?: InputMaybe<ImageSorting>
  link?: InputMaybe<LinkSorting>
  title?: InputMaybe<SortOrder>
  wideImage?: InputMaybe<ImageSorting>
}

export type BlockMenuSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  ariaLabel?: InputMaybe<SortOrder>
  layout?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  sectionLabel?: InputMaybe<SortOrder>
}

export type BlockOrMainImage = Block | MainImage

export type BlogAuthor = Document & {
  __typename?: 'BlogAuthor'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  bioRaw?: Maybe<Scalars['JSON']>
  image?: Maybe<MainImage>
  name?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
}

export type BlogAuthorFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  image?: InputMaybe<MainImageFilter>
  name?: InputMaybe<StringFilter>
  slug?: InputMaybe<SlugFilter>
}

export type BlogAuthorReference = {
  __typename?: 'BlogAuthorReference'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  author?: Maybe<BlogAuthor>
}

export type BlogAuthorReferenceFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  author?: InputMaybe<BlogAuthorFilter>
}

export type BlogAuthorReferenceSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type BlogAuthorSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  image?: InputMaybe<MainImageSorting>
  name?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
}

export type BlogCategory = Document & {
  __typename?: 'BlogCategory'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type BlogCategoryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type BlogCategorySorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type BlogPost = Document & {
  __typename?: 'BlogPost'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  authors?: Maybe<Array<Maybe<BlogAuthorReference>>>
  bodyRaw?: Maybe<Scalars['JSON']>
  category?: Maybe<BlogCategory>
  excerptRaw?: Maybe<Scalars['JSON']>
  /** For search engines. Will be added to /sitemap.xml */
  includeInSitemap?: Maybe<Scalars['Boolean']>
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>
  mainImage?: Maybe<MainImage>
  openGraphImage?: Maybe<Image>
  /** This can be used to schedule post for publishing */
  publishedAt?: Maybe<Scalars['DateTime']>
  /** For auto-generated links to share the post on Facebook, Twitter, etc. (displayed as social media icons) */
  showSocialLinks?: Maybe<Scalars['Boolean']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type BlogPostFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  category?: InputMaybe<BlogCategoryFilter>
  includeInSitemap?: InputMaybe<BooleanFilter>
  mainImage?: InputMaybe<MainImageFilter>
  openGraphImage?: InputMaybe<ImageFilter>
  publishedAt?: InputMaybe<DatetimeFilter>
  showSocialLinks?: InputMaybe<BooleanFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type BlogPostOrPageOrResearch = BlogPost | Page | Research

export type BlogPostSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  includeInSitemap?: InputMaybe<SortOrder>
  mainImage?: InputMaybe<MainImageSorting>
  openGraphImage?: InputMaybe<ImageSorting>
  publishedAt?: InputMaybe<SortOrder>
  showSocialLinks?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type BooleanFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Boolean']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Boolean']>
}

export type ButtonBlockSection = {
  __typename?: 'ButtonBlockSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  entries?: Maybe<Array<Maybe<Cta>>>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  title?: Maybe<Scalars['String']>
}

export type ButtonBlockSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  title?: InputMaybe<StringFilter>
}

export type ButtonBlockSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  title?: InputMaybe<SortOrder>
}

export type Carousel = {
  __typename?: 'Carousel'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  deck?: Maybe<CarouselDeck>
}

export type CarouselDeck = Document & {
  __typename?: 'CarouselDeck'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  slides?: Maybe<Array<Maybe<CarouselSlide>>>
  title?: Maybe<Scalars['String']>
}

export type CarouselDeckFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  title?: InputMaybe<StringFilter>
}

export type CarouselDeckSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type CarouselFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  deck?: InputMaybe<CarouselDeckFilter>
}

export type CarouselHalfHero = {
  __typename?: 'CarouselHalfHero'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  cta?: Maybe<Cta>
  /** Color used for the Call To Action background (default is DFH brand orange when not specified). */
  ctaBackgroundColor?: Maybe<SiteColor>
  /** Color used for the Call To Action text (default is white when not specified). */
  ctaTextColor?: Maybe<SiteColor>
  descriptionDesktop?: Maybe<Scalars['String']>
  descriptionMobile?: Maybe<Scalars['String']>
  /** Image fit options for the background if a background layout option is selected. */
  heroBackgroundImageFit?: Maybe<Scalars['String']>
  heroImage?: Maybe<Image>
  heroImageMobile?: Maybe<Image>
  /** Determines the image and text layout for the slider. */
  heroImageTextLayout?: Maybe<Scalars['String']>
  heroTextStyles?: Maybe<TextStyles>
  /** Color used for the full-width carousel slide background (default color is dark blue when not specified). */
  slideBackgroundColor?: Maybe<SiteColor>
  title?: Maybe<Scalars['String']>
  titleDesktop?: Maybe<Scalars['String']>
  titleMobile?: Maybe<Scalars['String']>
}

export type CarouselHalfHeroFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  cta?: InputMaybe<CtaFilter>
  ctaBackgroundColor?: InputMaybe<SiteColorFilter>
  ctaTextColor?: InputMaybe<SiteColorFilter>
  descriptionDesktop?: InputMaybe<StringFilter>
  descriptionMobile?: InputMaybe<StringFilter>
  heroBackgroundImageFit?: InputMaybe<StringFilter>
  heroImage?: InputMaybe<ImageFilter>
  heroImageMobile?: InputMaybe<ImageFilter>
  heroImageTextLayout?: InputMaybe<StringFilter>
  heroTextStyles?: InputMaybe<TextStylesFilter>
  slideBackgroundColor?: InputMaybe<SiteColorFilter>
  title?: InputMaybe<StringFilter>
  titleDesktop?: InputMaybe<StringFilter>
  titleMobile?: InputMaybe<StringFilter>
}

export type CarouselHalfHeroSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  cta?: InputMaybe<CtaSorting>
  descriptionDesktop?: InputMaybe<SortOrder>
  descriptionMobile?: InputMaybe<SortOrder>
  heroBackgroundImageFit?: InputMaybe<SortOrder>
  heroImage?: InputMaybe<ImageSorting>
  heroImageMobile?: InputMaybe<ImageSorting>
  heroImageTextLayout?: InputMaybe<SortOrder>
  heroTextStyles?: InputMaybe<TextStylesSorting>
  title?: InputMaybe<SortOrder>
  titleDesktop?: InputMaybe<SortOrder>
  titleMobile?: InputMaybe<SortOrder>
}

export type CarouselHero = {
  __typename?: 'CarouselHero'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  cta?: Maybe<Cta>
  heroImage?: Maybe<Image>
  title?: Maybe<Scalars['String']>
}

export type CarouselHeroFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  cta?: InputMaybe<CtaFilter>
  heroImage?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
}

export type CarouselHeroSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  cta?: InputMaybe<CtaSorting>
  heroImage?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type CarouselSlide = Document & {
  __typename?: 'CarouselSlide'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  carousel?: Maybe<Array<Maybe<CarouselHalfHero>>>
}

export type CarouselSlideFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
}

export type CarouselSlideSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
}

export type CarouselSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type CasiSession = Document & {
  __typename?: 'CasiSession'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
  wistiaShareUrl?: Maybe<Scalars['String']>
}

export type CasiSessionFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
  wistiaShareUrl?: InputMaybe<StringFilter>
}

export type CasiSessionOrCatalogTrainingOrCategoryBrochureOrJournalArticleOrLiteratureReferenceOrPatientBrochureOrPatientEducationOrPriceListOrPrivateLabelFormOrProductReferenceChartOrProtocolOrSocialMediaResourceOrTechSheetOrTechSheetFrenchOrWebinarOrWhitePaper =

    | CasiSession
    | CatalogTraining
    | CategoryBrochure
    | JournalArticle
    | LiteratureReference
    | PatientBrochure
    | PatientEducation
    | PriceList
    | PrivateLabelForm
    | ProductReferenceChart
    | Protocol
    | SocialMediaResource
    | TechSheet
    | TechSheetFrench
    | Webinar
    | WhitePaper

export type CasiSessionResource = ResourceCommonFields & {
  __typename?: 'CasiSessionResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
  wistiaShareUrl?: Maybe<Scalars['String']>
}

export type CasiSessionSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
  wistiaShareUrl?: InputMaybe<SortOrder>
}

export type CatalogTraining = Document & {
  __typename?: 'CatalogTraining'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type CatalogTrainingFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type CatalogTrainingResource = ResourceCommonFields & {
  __typename?: 'CatalogTrainingResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type CatalogTrainingSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type CategoryBrochure = Document & {
  __typename?: 'CategoryBrochure'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type CategoryBrochureFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type CategoryBrochureResource = ResourceCommonFields & {
  __typename?: 'CategoryBrochureResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type CategoryBrochureSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type CheckoutMarketingContent = Document & {
  __typename?: 'CheckoutMarketingContent'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  confirmationBanners?: Maybe<Array<Maybe<BannerWithText>>>
}

export type CheckoutMarketingContentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
}

export type CheckoutMarketingContentSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
}

export type CompanyMenuEntry = {
  __typename?: 'CompanyMenuEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contextBasedContent?: Maybe<ContextBasedContent>
  link?: Maybe<Link>
  name?: Maybe<Scalars['String']>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type CompanyMenuEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  contextBasedContent?: InputMaybe<ContextBasedContentFilter>
  link?: InputMaybe<LinkFilter>
  name?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type CompanyMenuEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  contextBasedContent?: InputMaybe<ContextBasedContentSorting>
  link?: InputMaybe<LinkSorting>
  name?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type ContextBasedContent = {
  __typename?: 'ContextBasedContent'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contexts?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Toggle conditional content based on context */
  enabled?: Maybe<Scalars['Boolean']>
}

export type ContextBasedContentFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  enabled?: InputMaybe<BooleanFilter>
}

export type ContextBasedContentSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  enabled?: InputMaybe<SortOrder>
}

export type ContextualDescription = {
  __typename?: 'ContextualDescription'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contexts?: Maybe<ContextBasedContent>
  descriptionRaw?: Maybe<Scalars['JSON']>
  roles?: Maybe<RoleBasedContent>
}

export type ContextualDescriptionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  contexts?: InputMaybe<ContextBasedContentFilter>
  roles?: InputMaybe<RoleBasedContentFilter>
}

export type ContextualDescriptionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  contexts?: InputMaybe<ContextBasedContentSorting>
  roles?: InputMaybe<RoleBasedContentSorting>
}

export type Country = {
  __typename?: 'Country'
  iso: Scalars['String']
  name: Scalars['String']
  regions: Array<Region>
}

export type CreditCardFlags = {
  __typename?: 'CreditCardFlags'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  amex?: Maybe<Scalars['Boolean']>
  discover?: Maybe<Scalars['Boolean']>
  mastercard?: Maybe<Scalars['Boolean']>
  visa?: Maybe<Scalars['Boolean']>
}

export type CreditCardFlagsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  amex?: InputMaybe<BooleanFilter>
  discover?: InputMaybe<BooleanFilter>
  mastercard?: InputMaybe<BooleanFilter>
  visa?: InputMaybe<BooleanFilter>
}

export type CreditCardFlagsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  amex?: InputMaybe<SortOrder>
  discover?: InputMaybe<SortOrder>
  mastercard?: InputMaybe<SortOrder>
  visa?: InputMaybe<SortOrder>
}

export type Cta = {
  __typename?: 'Cta'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  link?: Maybe<Link>
  title?: Maybe<Scalars['String']>
}

export type CtaBlockSection = {
  __typename?: 'CtaBlockSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  entries?: Maybe<Array<Maybe<Cta>>>
  roleBasedContent?: Maybe<RoleBasedContent>
  title?: Maybe<Scalars['String']>
}

export type CtaBlockSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  title?: InputMaybe<StringFilter>
}

export type CtaBlockSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  title?: InputMaybe<SortOrder>
}

export type CtaCardSection = {
  __typename?: 'CtaCardSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  link?: Maybe<Link>
  linkText?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  title?: Maybe<Scalars['String']>
}

export type CtaCardSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  link?: InputMaybe<LinkFilter>
  linkText?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  title?: InputMaybe<StringFilter>
}

export type CtaCardSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  link?: InputMaybe<LinkSorting>
  linkText?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  title?: InputMaybe<SortOrder>
}

export type CtaFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  link?: InputMaybe<LinkFilter>
  title?: InputMaybe<StringFilter>
}

export type CtaSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  link?: InputMaybe<LinkSorting>
  title?: InputMaybe<SortOrder>
}

export type CtaWithImage = {
  __typename?: 'CtaWithImage'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  image?: Maybe<MainImage>
  link?: Maybe<Link>
  title?: Maybe<Scalars['String']>
}

export type CtaWithImageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  image?: InputMaybe<MainImageFilter>
  link?: InputMaybe<LinkFilter>
  title?: InputMaybe<StringFilter>
}

export type CtaWithImageOrRichArticleDividerImageOrRichArticleTextSection =
  | CtaWithImage
  | RichArticleDividerImage
  | RichArticleTextSection

export type CtaWithImageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  image?: InputMaybe<MainImageSorting>
  link?: InputMaybe<LinkSorting>
  title?: InputMaybe<SortOrder>
}

export type CustomerFormEntry = {
  __typename?: 'CustomerFormEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  label?: Maybe<Scalars['String']>
  link?: Maybe<Scalars['String']>
}

export type CustomerFormEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  label?: InputMaybe<StringFilter>
  link?: InputMaybe<StringFilter>
}

export type CustomerFormEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  link?: InputMaybe<SortOrder>
}

export type DateFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Date']>
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Date']>
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Date']>
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Date']>
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Date']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Date']>
}

export type DatetimeFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['DateTime']>
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['DateTime']>
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['DateTime']>
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['DateTime']>
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['DateTime']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['DateTime']>
}

export type DispensaryBio = {
  __typename?: 'DispensaryBio'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Ignore the practitioner's customization and use the default instead */
  forceDefault?: Maybe<Scalars['Boolean']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type DispensaryBioFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  forceDefault?: InputMaybe<BooleanFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type DispensaryBioSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  forceDefault?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type DispensaryFeaturedProducts = {
  __typename?: 'DispensaryFeaturedProducts'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Ignore the practitioner's customization and use the default instead */
  forceDefault?: Maybe<Scalars['Boolean']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type DispensaryFeaturedProductsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  forceDefault?: InputMaybe<BooleanFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type DispensaryFeaturedProductsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  forceDefault?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type DispensaryHero = {
  __typename?: 'DispensaryHero'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Ignore the practitioner's customization and use the default instead */
  forceDefault?: Maybe<Scalars['Boolean']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type DispensaryHeroFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  forceDefault?: InputMaybe<BooleanFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type DispensaryHeroSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  forceDefault?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

/** A Sanity document */
export type Document = {
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
}

export type DocumentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
}

export type DocumentSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
}

export type Drug = Document & {
  __typename?: 'Drug'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  brandNamesRaw?: Maybe<Scalars['JSON']>
  cautionRaw?: Maybe<Scalars['JSON']>
  classRaw?: Maybe<Scalars['JSON']>
  commonUsesRaw?: Maybe<Scalars['JSON']>
  contraindicatedProducts?: Maybe<Array<Maybe<ParentProduct>>>
  depletionsRaw?: Maybe<Scalars['JSON']>
  inhibitsGenesRaw?: Maybe<Scalars['JSON']>
  metabolizedByGenesRaw?: Maybe<Scalars['JSON']>
  name?: Maybe<Scalars['String']>
  negativeInteractionsRaw?: Maybe<Scalars['JSON']>
  recommendedProducts?: Maybe<Array<Maybe<ParentProduct>>>
  referencesRaw?: Maybe<Scalars['JSON']>
  sideEffectsRaw?: Maybe<Scalars['JSON']>
  slug?: Maybe<Slug>
  snps?: Maybe<Array<Maybe<Snp>>>
  supportiveInteractionsRaw?: Maybe<Scalars['JSON']>
  upregulatesGenesRaw?: Maybe<Scalars['JSON']>
}

export type DrugFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  name?: InputMaybe<StringFilter>
  slug?: InputMaybe<SlugFilter>
}

export type DrugSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
}

export type ExternalLink = {
  __typename?: 'ExternalLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  blank?: Maybe<Scalars['Boolean']>
  href?: Maybe<Scalars['String']>
}

export type ExternalLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  blank?: InputMaybe<BooleanFilter>
  href?: InputMaybe<StringFilter>
}

export type ExternalLinkOrInternalLinkOrLibraryLinkOrLoginLinkOrPathLinkOrRegistrationLinkOrSupportRequestLink =

    | ExternalLink
    | InternalLink
    | LibraryLink
    | LoginLink
    | PathLink
    | RegistrationLink
    | SupportRequestLink

export type ExternalLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  blank?: InputMaybe<SortOrder>
  href?: InputMaybe<SortOrder>
}

export type FeaturedProductsBanner = {
  __typename?: 'FeaturedProductsBanner'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  products?: Maybe<Array<Maybe<ParentProduct>>>
  roleBasedContent?: Maybe<RoleBasedContent>
  subtitle?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type FeaturedProductsBannerFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  subtitle?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type FeaturedProductsBannerSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  subtitle?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type FeaturedProductsCarousel = {
  __typename?: 'FeaturedProductsCarousel'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Select background color (page section) from list of site colors. */
  backgroundColor?: Maybe<SiteColor>
  cta?: Maybe<Cta>
  /** Select background color from list of site colors. */
  ctaBackgroundColor?: Maybe<SiteColor>
  /** Select text color from list of site colors. */
  ctaTextColor?: Maybe<SiteColor>
  products?: Maybe<Array<Maybe<ParentProduct>>>
  roleBasedContent?: Maybe<RoleBasedContent>
  subtitle?: Maybe<Scalars['String']>
  /** Select text color from list of site colors. */
  textColor?: Maybe<SiteColor>
  title?: Maybe<Scalars['String']>
}

export type FeaturedProductsCarouselFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  backgroundColor?: InputMaybe<SiteColorFilter>
  cta?: InputMaybe<CtaFilter>
  ctaBackgroundColor?: InputMaybe<SiteColorFilter>
  ctaTextColor?: InputMaybe<SiteColorFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  subtitle?: InputMaybe<StringFilter>
  textColor?: InputMaybe<SiteColorFilter>
  title?: InputMaybe<StringFilter>
}

export type FeaturedProductsCarouselSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  cta?: InputMaybe<CtaSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  subtitle?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type File = {
  __typename?: 'File'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  asset?: Maybe<SanityFileAsset>
  url?: Maybe<Scalars['String']>
}

export type FileFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  asset?: InputMaybe<SanityFileAssetFilter>
}

export type FileSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type FloatFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Float']>
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Float']>
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Float']>
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Float']>
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Float']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Float']>
}

export type FreeShippingThresholds = {
  __typename?: 'FreeShippingThresholds'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  nonContiguousPatient?: Maybe<Scalars['Float']>
  nonContiguousProfessional?: Maybe<Scalars['Float']>
  patient?: Maybe<Scalars['Float']>
  professional?: Maybe<Scalars['Float']>
}

export type FreeShippingThresholdsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  nonContiguousPatient?: InputMaybe<FloatFilter>
  nonContiguousProfessional?: InputMaybe<FloatFilter>
  patient?: InputMaybe<FloatFilter>
  professional?: InputMaybe<FloatFilter>
}

export type FreeShippingThresholdsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  nonContiguousPatient?: InputMaybe<SortOrder>
  nonContiguousProfessional?: InputMaybe<SortOrder>
  patient?: InputMaybe<SortOrder>
  professional?: InputMaybe<SortOrder>
}

export type Geopoint = {
  __typename?: 'Geopoint'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  alt?: Maybe<Scalars['Float']>
  lat?: Maybe<Scalars['Float']>
  lng?: Maybe<Scalars['Float']>
}

export type GeopointFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  alt?: InputMaybe<FloatFilter>
  lat?: InputMaybe<FloatFilter>
  lng?: InputMaybe<FloatFilter>
}

export type GeopointSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  alt?: InputMaybe<SortOrder>
  lat?: InputMaybe<SortOrder>
  lng?: InputMaybe<SortOrder>
}

export type GlobalMarkets = {
  __typename?: 'GlobalMarkets'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  content?: Maybe<Scalars['String']>
  image?: Maybe<Image>
}

export type GlobalMarketsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  content?: InputMaybe<StringFilter>
  image?: InputMaybe<ImageFilter>
}

export type GlobalMarketsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  content?: InputMaybe<SortOrder>
  image?: InputMaybe<ImageSorting>
}

export type HelpCenterMenuEntry = {
  __typename?: 'HelpCenterMenuEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Optional field for a label that will prefix the link text */
  label?: Maybe<Scalars['String']>
  link?: Maybe<ExternalLink>
  linkText?: Maybe<Scalars['String']>
}

export type HelpCenterMenuEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  label?: InputMaybe<StringFilter>
  link?: InputMaybe<ExternalLinkFilter>
  linkText?: InputMaybe<StringFilter>
}

export type HelpCenterMenuEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  link?: InputMaybe<ExternalLinkSorting>
  linkText?: InputMaybe<SortOrder>
}

export type HelpMenuEntry = {
  __typename?: 'HelpMenuEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contextBasedContent?: Maybe<ContextBasedContent>
  link?: Maybe<Link>
  name?: Maybe<Scalars['String']>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type HelpMenuEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  contextBasedContent?: InputMaybe<ContextBasedContentFilter>
  link?: InputMaybe<LinkFilter>
  name?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type HelpMenuEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  contextBasedContent?: InputMaybe<ContextBasedContentSorting>
  link?: InputMaybe<LinkSorting>
  name?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type HeroTag = Document & {
  __typename?: 'HeroTag'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  cta?: Maybe<Cta>
  tag?: Maybe<Scalars['String']>
}

export type HeroTagFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  cta?: InputMaybe<CtaFilter>
  tag?: InputMaybe<StringFilter>
}

export type HeroTagSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  cta?: InputMaybe<CtaSorting>
  tag?: InputMaybe<SortOrder>
}

export type HubSpotForm = {
  __typename?: 'HubSpotForm'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** HubSpot form to render */
  formId?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
}

export type HubSpotFormFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  formId?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
}

export type HubSpotFormSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  formId?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
}

export type IdFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['ID']>
  in?: InputMaybe<Array<Scalars['ID']>>
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['ID']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['ID']>
  nin?: InputMaybe<Array<Scalars['ID']>>
}

export type IconAndText = {
  __typename?: 'IconAndText'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  icon?: Maybe<Image>
  textRaw?: Maybe<Scalars['JSON']>
  title?: Maybe<Scalars['String']>
}

export type IconAndTextFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  icon?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
}

export type IconAndTextGrid = {
  __typename?: 'IconAndTextGrid'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  entries?: Maybe<Array<Maybe<IconAndText>>>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  /** Header displayed above group of icons/text. */
  title?: Maybe<Scalars['String']>
}

export type IconAndTextGridFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  title?: InputMaybe<StringFilter>
}

export type IconAndTextGridSmall = {
  __typename?: 'IconAndTextGridSmall'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  entries?: Maybe<Array<Maybe<IconAndText>>>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  title?: Maybe<Scalars['String']>
}

export type IconAndTextGridSmallFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  title?: InputMaybe<StringFilter>
}

export type IconAndTextGridSmallSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  title?: InputMaybe<SortOrder>
}

export type IconAndTextGridSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  title?: InputMaybe<SortOrder>
}

export type IconAndTextSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  icon?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type Image = {
  __typename?: 'Image'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  asset?: Maybe<SanityImageAsset>
  crop?: Maybe<SanityImageCrop>
  hotspot?: Maybe<SanityImageHotspot>
}

export type ImageAndTextSection = {
  __typename?: 'ImageAndTextSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  image?: Maybe<Image>
  layout?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  subtitle?: Maybe<Scalars['String']>
  textAlign?: Maybe<Scalars['String']>
  textRaw?: Maybe<Scalars['JSON']>
  title?: Maybe<Scalars['String']>
}

export type ImageAndTextSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  image?: InputMaybe<ImageFilter>
  layout?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  subtitle?: InputMaybe<StringFilter>
  textAlign?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type ImageAndTextSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  image?: InputMaybe<ImageSorting>
  layout?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  subtitle?: InputMaybe<SortOrder>
  textAlign?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type ImageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  asset?: InputMaybe<SanityImageAssetFilter>
  crop?: InputMaybe<SanityImageCropFilter>
  hotspot?: InputMaybe<SanityImageHotspotFilter>
}

export type ImageResource = {
  __typename?: 'ImageResource'
  _type?: Maybe<Scalars['String']>
  asset?: Maybe<ImageResourceAsset>
}

export type ImageResourceAsset = {
  __typename?: 'ImageResourceAsset'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type ImageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  crop?: InputMaybe<SanityImageCropSorting>
  hotspot?: InputMaybe<SanityImageHotspotSorting>
}

export type Instapage = {
  __typename?: 'Instapage'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Path of the Instapage URL to embed, excluding the domain. */
  instapagePath?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
}

export type InstapageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  instapagePath?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
}

export type InstapageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  instapagePath?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
}

export type IntFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['Int']>
  /** Checks if the value is greater than the given input. */
  gt?: InputMaybe<Scalars['Int']>
  /** Checks if the value is greater than or equal to the given input. */
  gte?: InputMaybe<Scalars['Int']>
  /** Checks if the value is lesser than the given input. */
  lt?: InputMaybe<Scalars['Int']>
  /** Checks if the value is lesser than or equal to the given input. */
  lte?: InputMaybe<Scalars['Int']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['Int']>
}

export type InternalLink = {
  __typename?: 'InternalLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  reference?: Maybe<BlogPostOrPageOrResearch>
}

export type InternalLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type InternalLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type JournalArticle = Document & {
  __typename?: 'JournalArticle'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type JournalArticleFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type JournalArticleResource = ResourceCommonFields & {
  __typename?: 'JournalArticleResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type JournalArticleSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type LeadershipGrid = {
  __typename?: 'LeadershipGrid'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  groups?: Maybe<Array<Maybe<LeadershipGroup>>>
}

export type LeadershipGridFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type LeadershipGridSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type LeadershipGroup = {
  __typename?: 'LeadershipGroup'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Layout rules - "2 col x 1 row" expects 2 members, "4 col x 1 row" expects 4 members, "2 col rowspan left" expects 3 members (1st member in "2 col rowspan left" group will be displayed in left rowspan) */
  layout?: Maybe<Scalars['String']>
  members?: Maybe<Array<Maybe<TeamMemberLeadership>>>
}

export type LeadershipGroupFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  layout?: InputMaybe<StringFilter>
}

export type LeadershipGroupSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  layout?: InputMaybe<SortOrder>
}

export type Library = {
  __typename?: 'Library'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** This description populates meta-tags on the webpage */
  description?: Maybe<Scalars['String']>
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>
  openGraphImage?: Maybe<Image>
  title?: Maybe<Scalars['String']>
}

export type LibraryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  description?: InputMaybe<StringFilter>
  openGraphImage?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
}

export type LibraryLink = {
  __typename?: 'LibraryLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  reference?: Maybe<CasiSessionOrCatalogTrainingOrCategoryBrochureOrJournalArticleOrLiteratureReferenceOrPatientBrochureOrPatientEducationOrPriceListOrPrivateLabelFormOrProductReferenceChartOrProtocolOrSocialMediaResourceOrTechSheetOrTechSheetFrenchOrWebinarOrWhitePaper>
}

export type LibraryLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type LibraryLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type LibrarySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  openGraphImage?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type Link = {
  __typename?: 'Link'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  target?: Maybe<
    Array<
      Maybe<ExternalLinkOrInternalLinkOrLibraryLinkOrLoginLinkOrPathLinkOrRegistrationLinkOrSupportRequestLink>
    >
  >
}

export type LinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type LinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type LiteratureReference = Document & {
  __typename?: 'LiteratureReference'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type LiteratureReferenceFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type LiteratureReferenceResource = ResourceCommonFields & {
  __typename?: 'LiteratureReferenceResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type LiteratureReferenceSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type LoginLink = {
  __typename?: 'LoginLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Toggle redirect to other path after login */
  enableRedirect?: Maybe<Scalars['Boolean']>
  /** Path to redirect user after login */
  redirectPath?: Maybe<Scalars['String']>
  /** Redirect to current page after login */
  redirectToCurrentPage?: Maybe<Scalars['Boolean']>
}

export type LoginLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  enableRedirect?: InputMaybe<BooleanFilter>
  redirectPath?: InputMaybe<StringFilter>
  redirectToCurrentPage?: InputMaybe<BooleanFilter>
}

export type LoginLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  enableRedirect?: InputMaybe<SortOrder>
  redirectPath?: InputMaybe<SortOrder>
  redirectToCurrentPage?: InputMaybe<SortOrder>
}

export type LogoDividerSection = {
  __typename?: 'LogoDividerSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Important for SEO and accessiblity. */
  alt?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
}

export type LogoDividerSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  alt?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
}

export type LogoDividerSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  alt?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
}

export type MainImage = {
  __typename?: 'MainImage'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Important for SEO and accessiblity. */
  alt?: Maybe<Scalars['String']>
  asset?: Maybe<SanityImageAsset>
  caption?: Maybe<Scalars['String']>
  crop?: Maybe<SanityImageCrop>
  hotspot?: Maybe<SanityImageHotspot>
}

export type MainImageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  alt?: InputMaybe<StringFilter>
  asset?: InputMaybe<SanityImageAssetFilter>
  caption?: InputMaybe<StringFilter>
  crop?: InputMaybe<SanityImageCropFilter>
  hotspot?: InputMaybe<SanityImageHotspotFilter>
}

export type MainImageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  alt?: InputMaybe<SortOrder>
  caption?: InputMaybe<SortOrder>
  crop?: InputMaybe<SanityImageCropSorting>
  hotspot?: InputMaybe<SanityImageHotspotSorting>
}

export type MenuEntry = Document & {
  __typename?: 'MenuEntry'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  childEntries?: Maybe<Array<Maybe<MenuEntry>>>
  contextBasedContent?: Maybe<ContextBasedContent>
  link?: Maybe<Link>
  name?: Maybe<Scalars['String']>
  /**
   * Only applies to second-level desktop menu entries.
   *         Specifies when to break columns in mega menu.
   */
  newColumn?: Maybe<Scalars['Boolean']>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type MenuEntryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  contextBasedContent?: InputMaybe<ContextBasedContentFilter>
  link?: InputMaybe<LinkFilter>
  name?: InputMaybe<StringFilter>
  newColumn?: InputMaybe<BooleanFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type MenuEntrySorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  contextBasedContent?: InputMaybe<ContextBasedContentSorting>
  link?: InputMaybe<LinkSorting>
  name?: InputMaybe<SortOrder>
  newColumn?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type Money = {
  __typename?: 'Money'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  amount?: Maybe<Scalars['String']>
  currency?: Maybe<Scalars['String']>
}

export type MoneyFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  amount?: InputMaybe<StringFilter>
  currency?: InputMaybe<StringFilter>
}

export type MoneySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  amount?: InputMaybe<SortOrder>
  currency?: InputMaybe<SortOrder>
}

export type NoSearchResultsFound = {
  __typename?: 'NoSearchResultsFound'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  recommendedCategories?: Maybe<Array<Maybe<MenuEntry>>>
  recommendedProducts?: Maybe<Array<Maybe<ParentProduct>>>
}

export type NoSearchResultsFoundFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type NoSearchResultsFoundSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type Notification = {
  __typename?: 'Notification'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  notificationMessage?: Maybe<NotificationMessage>
}

export type NotificationFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  notificationMessage?: InputMaybe<NotificationMessageFilter>
}

export type NotificationMessage = Document & {
  __typename?: 'NotificationMessage'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  content?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type NotificationMessageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  content?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type NotificationMessageSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  content?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type NotificationSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type OnboardingPromotion = {
  __typename?: 'OnboardingPromotion'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  callToActions?: Maybe<Array<Maybe<Cta>>>
  descriptionRaw?: Maybe<Scalars['JSON']>
  image?: Maybe<Image>
  subtitleRaw?: Maybe<Scalars['JSON']>
  title?: Maybe<Scalars['String']>
}

export type OnboardingPromotionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  image?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
}

export type OnboardingPromotionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  image?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type Page = Document & {
  __typename?: 'Page'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  content?: Maybe<
    Array<
      Maybe<BannerWithArticleOrBannerWithTextOrBasicArticleOrBasicTextSectionOrBlockMenuOrBlockMenuAdditionalShortcutsOrBlockMenuCtaOrButtonBlockSectionOrCarouselOrCtaBlockSectionOrCtaCardSectionOrDispensaryBioOrDispensaryFeaturedProductsOrDispensaryHeroOrFeaturedProductsBannerOrFeaturedProductsCarouselOrGlobalMarketsOrHubSpotFormOrIconAndTextGridOrIconAndTextGridSmallOrImageAndTextSectionOrInstapageOrLeadershipGridOrLibraryOrLogoDividerSectionOrNotificationOrPageHeroOrProductSpotlightOrRegistrationPageOrRichArticleOrScienceTeamGridOrSpacerSectionOrTableSectionOrTermsSectionOrVideoSection>
    >
  >
  /** This description populates meta-tags on the webpage */
  description?: Maybe<Scalars['String']>
  /** For search engines. Will be added to /sitemap.xml */
  includeInSitemap?: Maybe<Scalars['Boolean']>
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>
  /** The max-width value for the page (default is 1280px). */
  maxWidth?: Maybe<Scalars['String']>
  openGraphImage?: Maybe<Image>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PageFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  includeInSitemap?: InputMaybe<BooleanFilter>
  maxWidth?: InputMaybe<StringFilter>
  openGraphImage?: InputMaybe<ImageFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type PageHero = {
  __typename?: 'PageHero'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  heroImage?: Maybe<Scalars['String']>
  heroTag?: Maybe<HeroTag>
  isTitleTopLevelHeader?: Maybe<Scalars['Boolean']>
  title?: Maybe<Scalars['String']>
}

export type PageHeroFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  heroImage?: InputMaybe<StringFilter>
  heroTag?: InputMaybe<HeroTagFilter>
  isTitleTopLevelHeader?: InputMaybe<BooleanFilter>
  title?: InputMaybe<StringFilter>
}

export type PageHeroSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  heroImage?: InputMaybe<SortOrder>
  isTitleTopLevelHeader?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type PageSectionStyles = {
  __typename?: 'PageSectionStyles'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  marginBottom?: Maybe<Scalars['String']>
  marginTop?: Maybe<Scalars['String']>
  paddingBottom?: Maybe<Scalars['String']>
  paddingTop?: Maybe<Scalars['String']>
}

export type PageSectionStylesFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  marginBottom?: InputMaybe<StringFilter>
  marginTop?: InputMaybe<StringFilter>
  paddingBottom?: InputMaybe<StringFilter>
  paddingTop?: InputMaybe<StringFilter>
}

export type PageSectionStylesSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  marginBottom?: InputMaybe<SortOrder>
  marginTop?: InputMaybe<SortOrder>
  paddingBottom?: InputMaybe<SortOrder>
  paddingTop?: InputMaybe<SortOrder>
}

export type PageSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  includeInSitemap?: InputMaybe<SortOrder>
  maxWidth?: InputMaybe<SortOrder>
  openGraphImage?: InputMaybe<ImageSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type ParentProduct = Document & {
  __typename?: 'ParentProduct'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  ailments?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Allow this product to be included in events reported to third party service providers (e.g. `Purchase` events sent to Meta/Facebook). */
  allowInThirdPartyEvents?: Maybe<Scalars['Boolean']>
  /** Brand used for JSON-LD and SEO purposes. */
  brand?: Maybe<Scalars['String']>
  contextualDescription?: Maybe<Array<Maybe<ContextualDescription>>>
  defaultDescriptionRaw?: Maybe<Scalars['JSON']>
  image?: Maybe<Image>
  ingredients?: Maybe<Array<Maybe<Scalars['String']>>>
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>
  /** This description populates meta-tags on the webpage */
  metaDescription?: Maybe<Scalars['String']>
  openGraphImage?: Maybe<Image>
  products?: Maybe<Array<Maybe<Product>>>
  relatedProducts?: Maybe<Array<Maybe<ParentProduct>>>
  relatedProductsSubtitle?: Maybe<Scalars['String']>
  relatedProductsTitle?: Maybe<Scalars['String']>
  shortDescription?: Maybe<Scalars['String']>
  sku?: Maybe<Scalars['String']>
  tagline?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type ParentProductFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  allowInThirdPartyEvents?: InputMaybe<BooleanFilter>
  brand?: InputMaybe<StringFilter>
  image?: InputMaybe<ImageFilter>
  metaDescription?: InputMaybe<StringFilter>
  openGraphImage?: InputMaybe<ImageFilter>
  relatedProductsSubtitle?: InputMaybe<StringFilter>
  relatedProductsTitle?: InputMaybe<StringFilter>
  shortDescription?: InputMaybe<StringFilter>
  sku?: InputMaybe<StringFilter>
  tagline?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type ParentProductSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  allowInThirdPartyEvents?: InputMaybe<SortOrder>
  brand?: InputMaybe<SortOrder>
  image?: InputMaybe<ImageSorting>
  metaDescription?: InputMaybe<SortOrder>
  openGraphImage?: InputMaybe<ImageSorting>
  relatedProductsSubtitle?: InputMaybe<SortOrder>
  relatedProductsTitle?: InputMaybe<SortOrder>
  shortDescription?: InputMaybe<SortOrder>
  sku?: InputMaybe<SortOrder>
  tagline?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type PathLink = {
  __typename?: 'PathLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  path?: Maybe<Scalars['String']>
}

export type PathLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  path?: InputMaybe<StringFilter>
}

export type PathLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  path?: InputMaybe<SortOrder>
}

export type PatientBrochure = Document & {
  __typename?: 'PatientBrochure'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PatientBrochureFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type PatientBrochureResource = ResourceCommonFields & {
  __typename?: 'PatientBrochureResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PatientBrochureSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type PatientEducation = Document & {
  __typename?: 'PatientEducation'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PatientEducationFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type PatientEducationResource = ResourceCommonFields & {
  __typename?: 'PatientEducationResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PatientEducationSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type PharmacyContent = Document & {
  __typename?: 'PharmacyContent'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PharmacyContentFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type PharmacyContentResource = ResourceCommonFields & {
  __typename?: 'PharmacyContentResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PharmacyContentSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type PharmacyLibraryResource =
  | CasiSessionResource
  | CatalogTrainingResource
  | CategoryBrochureResource
  | JournalArticleResource
  | LiteratureReferenceResource
  | PatientBrochureResource
  | PatientEducationResource
  | PharmacyContentResource
  | PriceListResource
  | PrivateLabelFormResource
  | ProductReferenceChartResource
  | ProtocolResource
  | SocialMediaResourceResource
  | TechSheetFrenchResource
  | TechSheetResource
  | WebinarResource
  | WhitePaperResource

export type PharmacyResourceFilters = {
  name?: InputMaybe<Array<InputMaybe<ResourcesFilterNameRange>>>
  searchKeyword?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Array<InputMaybe<PharmacyResourceType>>>
}

export const PharmacyResourceType = {
  CasiSession: 'casiSession',
  CatalogTraining: 'catalogTraining',
  CategoryBrochure: 'categoryBrochure',
  JournalArticle: 'journalArticle',
  LiteratureReference: 'literatureReference',
  PatientBrochure: 'patientBrochure',
  PatientEducation: 'patientEducation',
  PharmacyContent: 'pharmacyContent',
  PriceList: 'priceList',
  PrivateLabelForm: 'privateLabelForm',
  ProductReferenceChart: 'productReferenceChart',
  Protocol: 'protocol',
  SocialMediaResource: 'socialMediaResource',
  TechSheet: 'techSheet',
  TechSheetFrench: 'techSheetFrench',
  Webinar: 'webinar',
  WhitePaper: 'whitePaper',
} as const

export type PharmacyResourceType = (typeof PharmacyResourceType)[keyof typeof PharmacyResourceType]
export type PriceList = Document & {
  __typename?: 'PriceList'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PriceListFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type PriceListResource = ResourceCommonFields & {
  __typename?: 'PriceListResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PriceListSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type Prices = {
  __typename?: 'Prices'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  retail?: Maybe<Money>
}

export type PricesFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  retail?: InputMaybe<MoneyFilter>
}

export type PricesSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  retail?: InputMaybe<MoneySorting>
}

export type PrivateLabelForm = Document & {
  __typename?: 'PrivateLabelForm'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PrivateLabelFormFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type PrivateLabelFormResource = ResourceCommonFields & {
  __typename?: 'PrivateLabelFormResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type PrivateLabelFormSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type Product = Document & {
  __typename?: 'Product'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  contextualDescription?: Maybe<Array<Maybe<ContextualDescription>>>
  defaultDescriptionRaw?: Maybe<Scalars['JSON']>
  mainImage?: Maybe<ProductImage>
  otherImages?: Maybe<Array<Maybe<ProductImage>>>
  prices?: Maybe<Prices>
  product?: Maybe<ProductReference>
  protocols?: Maybe<Array<ProtocolResource>>
  quantity?: Maybe<Scalars['Int']>
  sku?: Maybe<Scalars['String']>
}

export type ProductFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  mainImage?: InputMaybe<ProductImageFilter>
  prices?: InputMaybe<PricesFilter>
  sku?: InputMaybe<StringFilter>
}

export type ProductImage = {
  __typename?: 'ProductImage'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Important for SEO and accessibility. */
  alt?: Maybe<Scalars['String']>
  asset?: Maybe<SanityImageAsset>
  crop?: Maybe<SanityImageCrop>
  hotspot?: Maybe<SanityImageHotspot>
}

export type ProductImageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  alt?: InputMaybe<StringFilter>
  asset?: InputMaybe<SanityImageAssetFilter>
  crop?: InputMaybe<SanityImageCropFilter>
  hotspot?: InputMaybe<SanityImageHotspotFilter>
}

export type ProductImageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  alt?: InputMaybe<SortOrder>
  crop?: InputMaybe<SanityImageCropSorting>
  hotspot?: InputMaybe<SanityImageHotspotSorting>
}

export type ProductReference = {
  __typename?: 'ProductReference'
  sku?: Maybe<Scalars['String']>
}

export type ProductReferenceChart = Document & {
  __typename?: 'ProductReferenceChart'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type ProductReferenceChartFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type ProductReferenceChartResource = ResourceCommonFields & {
  __typename?: 'ProductReferenceChartResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type ProductReferenceChartSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type ProductSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  mainImage?: InputMaybe<ProductImageSorting>
  prices?: InputMaybe<PricesSorting>
  sku?: InputMaybe<SortOrder>
}

export type ProductSpotlight = {
  __typename?: 'ProductSpotlight'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  backgroundStyles?: Maybe<BackgroundStyles>
  /** Description displayed above group of featured products. */
  description?: Maybe<Scalars['String']>
  products?: Maybe<Array<Maybe<SpotlightProduct>>>
  /** Header displayed above group of featured products. */
  title?: Maybe<Scalars['String']>
}

export type ProductSpotlightFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  backgroundStyles?: InputMaybe<BackgroundStylesFilter>
  description?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type ProductSpotlightSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  backgroundStyles?: InputMaybe<BackgroundStylesSorting>
  description?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type ProfessionalLibraryResource =
  | CasiSessionResource
  | CatalogTrainingResource
  | CategoryBrochureResource
  | JournalArticleResource
  | LiteratureReferenceResource
  | PatientBrochureResource
  | PatientEducationResource
  | PriceListResource
  | PrivateLabelFormResource
  | ProductReferenceChartResource
  | ProtocolResource
  | SocialMediaResourceResource
  | TechSheetFrenchResource
  | TechSheetResource
  | WebinarResource
  | WhitePaperResource

export type ProfessionalResourceFilters = {
  name?: InputMaybe<Array<InputMaybe<ResourcesFilterNameRange>>>
  searchKeyword?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Array<InputMaybe<ProfessionalResourceType>>>
}

export const ProfessionalResourceType = {
  CasiSession: 'casiSession',
  CatalogTraining: 'catalogTraining',
  CategoryBrochure: 'categoryBrochure',
  JournalArticle: 'journalArticle',
  LiteratureReference: 'literatureReference',
  PatientBrochure: 'patientBrochure',
  PatientEducation: 'patientEducation',
  PriceList: 'priceList',
  PrivateLabelForm: 'privateLabelForm',
  ProductReferenceChart: 'productReferenceChart',
  Protocol: 'protocol',
  SocialMediaResource: 'socialMediaResource',
  TechSheet: 'techSheet',
  TechSheetFrench: 'techSheetFrench',
  Webinar: 'webinar',
  WhitePaper: 'whitePaper',
} as const

export type ProfessionalResourceType =
  (typeof ProfessionalResourceType)[keyof typeof ProfessionalResourceType]
export type Protocol = Document & {
  __typename?: 'Protocol'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  bodyRaw?: Maybe<Scalars['JSON']>
  products?: Maybe<Array<Maybe<ProtocolProduct>>>
  productsAdjunct?: Maybe<Array<Maybe<ProtocolProduct>>>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type ProtocolFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type ProtocolProduct = {
  __typename?: 'ProtocolProduct'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  product?: Maybe<Product>
  quantity?: Maybe<Scalars['Float']>
}

export type ProtocolProductFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  product?: InputMaybe<ProductFilter>
  quantity?: InputMaybe<FloatFilter>
}

export type ProtocolProductSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  quantity?: InputMaybe<SortOrder>
}

export type ProtocolResource = ResourceCommonFields & {
  __typename?: 'ProtocolResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  bodyRaw?: Maybe<Scalars['JSON']>
  products?: Maybe<Array<Maybe<Product>>>
  productsAdjunct?: Maybe<Array<Maybe<Product>>>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type ProtocolSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type PublicLibraryResource =
  | CasiSessionResource
  | PatientBrochureResource
  | PatientEducationResource

export type PublicResourceFilters = {
  name?: InputMaybe<Array<InputMaybe<ResourcesFilterNameRange>>>
  searchKeyword?: InputMaybe<Scalars['String']>
  type?: InputMaybe<Array<InputMaybe<PublicResourceType>>>
}

export const PublicResourceType = {
  CasiSession: 'casiSession',
  PatientBrochure: 'patientBrochure',
  PatientEducation: 'patientEducation',
} as const

export type PublicResourceType = (typeof PublicResourceType)[keyof typeof PublicResourceType]
export type Query = {
  __typename?: 'Query'
  BlogAuthor?: Maybe<BlogAuthor>
  BlogCategory?: Maybe<BlogCategory>
  BlogPost?: Maybe<BlogPost>
  CarouselDeck?: Maybe<CarouselDeck>
  CarouselSlide?: Maybe<CarouselSlide>
  CasiSession?: Maybe<CasiSession>
  CatalogTraining?: Maybe<CatalogTraining>
  CategoryBrochure?: Maybe<CategoryBrochure>
  CheckoutMarketingContent?: Maybe<CheckoutMarketingContent>
  Document?: Maybe<Document>
  Drug?: Maybe<Drug>
  HeroTag?: Maybe<HeroTag>
  JournalArticle?: Maybe<JournalArticle>
  LiteratureReference?: Maybe<LiteratureReference>
  MenuEntry?: Maybe<MenuEntry>
  NotificationMessage?: Maybe<NotificationMessage>
  Page?: Maybe<Page>
  ParentProduct?: Maybe<ParentProduct>
  PatientBrochure?: Maybe<PatientBrochure>
  PatientEducation?: Maybe<PatientEducation>
  PharmacyContent?: Maybe<PharmacyContent>
  PriceList?: Maybe<PriceList>
  PrivateLabelForm?: Maybe<PrivateLabelForm>
  Product?: Maybe<Product>
  ProductReferenceChart?: Maybe<ProductReferenceChart>
  Protocol?: Maybe<Protocol>
  Research?: Maybe<Research>
  ResearchCategory?: Maybe<ResearchCategory>
  SanityFileAsset?: Maybe<SanityFileAsset>
  SanityImageAsset?: Maybe<SanityImageAsset>
  ShippingCountry?: Maybe<ShippingCountry>
  SiteColor?: Maybe<SiteColor>
  SiteSettings?: Maybe<SiteSettings>
  SocialMediaResource?: Maybe<SocialMediaResource>
  TeamMemberLeadership?: Maybe<TeamMemberLeadership>
  TeamMemberScience?: Maybe<TeamMemberScience>
  TechSheet?: Maybe<TechSheet>
  TechSheetFrench?: Maybe<TechSheetFrench>
  Terms?: Maybe<Terms>
  Webinar?: Maybe<Webinar>
  WhitePaper?: Maybe<WhitePaper>
  allBlogAuthor: Array<BlogAuthor>
  allBlogCategory: Array<BlogCategory>
  allBlogPost: Array<BlogPost>
  allCarouselDeck: Array<CarouselDeck>
  allCarouselSlide: Array<CarouselSlide>
  allCasiSession: Array<CasiSession>
  allCatalogTraining: Array<CatalogTraining>
  allCategoryBrochure: Array<CategoryBrochure>
  allCheckoutMarketingContent: Array<CheckoutMarketingContent>
  allCountries: Array<Maybe<Country>>
  allDocument: Array<Document>
  allDrug: Array<Drug>
  allHeroTag: Array<HeroTag>
  allJournalArticle: Array<JournalArticle>
  allLiteratureReference: Array<LiteratureReference>
  allMenuEntry: Array<MenuEntry>
  allNotificationMessage: Array<NotificationMessage>
  allPage: Array<Page>
  allParentProduct: Array<ParentProduct>
  allPatientBrochure: Array<PatientBrochure>
  allPatientEducation: Array<PatientEducation>
  allPharmacyContent: Array<PharmacyContent>
  allPharmacyLibraryResources?: Maybe<AllPharmacyLibraryResources>
  allPriceList: Array<PriceList>
  allPrivateLabelForm: Array<PrivateLabelForm>
  allProduct: Array<Product>
  allProductReferenceChart: Array<ProductReferenceChart>
  allProfessionalLibraryResources?: Maybe<AllProfessionalLibraryResources>
  allProtocol: Array<Protocol>
  allPublicLibraryResources?: Maybe<AllPublicLibraryResources>
  allResearch: Array<Research>
  allResearchCategory: Array<ResearchCategory>
  allSanityFileAsset: Array<SanityFileAsset>
  allSanityImageAsset: Array<SanityImageAsset>
  allShippingCountry: Array<ShippingCountry>
  allSiteColor: Array<SiteColor>
  allSiteSettings: Array<SiteSettings>
  allSocialMediaResource: Array<SocialMediaResource>
  allTeamMemberLeadership: Array<TeamMemberLeadership>
  allTeamMemberScience: Array<TeamMemberScience>
  allTechSheet: Array<TechSheet>
  allTechSheetFrench: Array<TechSheetFrench>
  allTerms: Array<Terms>
  allWebinar: Array<Webinar>
  allWhitePaper: Array<WhitePaper>
  casiSessionResource?: Maybe<CasiSessionResource>
  country?: Maybe<Country>
  protocolResource?: Maybe<ProtocolResource>
  socialMediaResourceResource?: Maybe<SocialMediaResourceResource>
  webinarResource?: Maybe<WebinarResource>
}

export type QueryBlogAuthorArgs = {
  id: Scalars['ID']
}

export type QueryBlogCategoryArgs = {
  id: Scalars['ID']
}

export type QueryBlogPostArgs = {
  id: Scalars['ID']
}

export type QueryCarouselDeckArgs = {
  id: Scalars['ID']
}

export type QueryCarouselSlideArgs = {
  id: Scalars['ID']
}

export type QueryCasiSessionArgs = {
  id: Scalars['ID']
}

export type QueryCatalogTrainingArgs = {
  id: Scalars['ID']
}

export type QueryCategoryBrochureArgs = {
  id: Scalars['ID']
}

export type QueryCheckoutMarketingContentArgs = {
  id: Scalars['ID']
}

export type QueryDocumentArgs = {
  id: Scalars['ID']
}

export type QueryDrugArgs = {
  id: Scalars['ID']
}

export type QueryHeroTagArgs = {
  id: Scalars['ID']
}

export type QueryJournalArticleArgs = {
  id: Scalars['ID']
}

export type QueryLiteratureReferenceArgs = {
  id: Scalars['ID']
}

export type QueryMenuEntryArgs = {
  id: Scalars['ID']
}

export type QueryNotificationMessageArgs = {
  id: Scalars['ID']
}

export type QueryPageArgs = {
  id: Scalars['ID']
}

export type QueryParentProductArgs = {
  id: Scalars['ID']
}

export type QueryPatientBrochureArgs = {
  id: Scalars['ID']
}

export type QueryPatientEducationArgs = {
  id: Scalars['ID']
}

export type QueryPharmacyContentArgs = {
  id: Scalars['ID']
}

export type QueryPriceListArgs = {
  id: Scalars['ID']
}

export type QueryPrivateLabelFormArgs = {
  id: Scalars['ID']
}

export type QueryProductArgs = {
  id: Scalars['ID']
}

export type QueryProductReferenceChartArgs = {
  id: Scalars['ID']
}

export type QueryProtocolArgs = {
  id: Scalars['ID']
}

export type QueryResearchArgs = {
  id: Scalars['ID']
}

export type QueryResearchCategoryArgs = {
  id: Scalars['ID']
}

export type QuerySanityFileAssetArgs = {
  id: Scalars['ID']
}

export type QuerySanityImageAssetArgs = {
  id: Scalars['ID']
}

export type QueryShippingCountryArgs = {
  id: Scalars['ID']
}

export type QuerySiteColorArgs = {
  id: Scalars['ID']
}

export type QuerySiteSettingsArgs = {
  id: Scalars['ID']
}

export type QuerySocialMediaResourceArgs = {
  id: Scalars['ID']
}

export type QueryTeamMemberLeadershipArgs = {
  id: Scalars['ID']
}

export type QueryTeamMemberScienceArgs = {
  id: Scalars['ID']
}

export type QueryTechSheetArgs = {
  id: Scalars['ID']
}

export type QueryTechSheetFrenchArgs = {
  id: Scalars['ID']
}

export type QueryTermsArgs = {
  id: Scalars['ID']
}

export type QueryWebinarArgs = {
  id: Scalars['ID']
}

export type QueryWhitePaperArgs = {
  id: Scalars['ID']
}

export type QueryAllBlogAuthorArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<BlogAuthorSorting>>
  where?: InputMaybe<BlogAuthorFilter>
}

export type QueryAllBlogCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<BlogCategorySorting>>
  where?: InputMaybe<BlogCategoryFilter>
}

export type QueryAllBlogPostArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<BlogPostSorting>>
  where?: InputMaybe<BlogPostFilter>
}

export type QueryAllCarouselDeckArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<CarouselDeckSorting>>
  where?: InputMaybe<CarouselDeckFilter>
}

export type QueryAllCarouselSlideArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<CarouselSlideSorting>>
  where?: InputMaybe<CarouselSlideFilter>
}

export type QueryAllCasiSessionArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<CasiSessionSorting>>
  where?: InputMaybe<CasiSessionFilter>
}

export type QueryAllCatalogTrainingArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<CatalogTrainingSorting>>
  where?: InputMaybe<CatalogTrainingFilter>
}

export type QueryAllCategoryBrochureArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<CategoryBrochureSorting>>
  where?: InputMaybe<CategoryBrochureFilter>
}

export type QueryAllCheckoutMarketingContentArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<CheckoutMarketingContentSorting>>
  where?: InputMaybe<CheckoutMarketingContentFilter>
}

export type QueryAllDocumentArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<DocumentSorting>>
  where?: InputMaybe<DocumentFilter>
}

export type QueryAllDrugArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<DrugSorting>>
  where?: InputMaybe<DrugFilter>
}

export type QueryAllHeroTagArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<HeroTagSorting>>
  where?: InputMaybe<HeroTagFilter>
}

export type QueryAllJournalArticleArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<JournalArticleSorting>>
  where?: InputMaybe<JournalArticleFilter>
}

export type QueryAllLiteratureReferenceArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<LiteratureReferenceSorting>>
  where?: InputMaybe<LiteratureReferenceFilter>
}

export type QueryAllMenuEntryArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<MenuEntrySorting>>
  where?: InputMaybe<MenuEntryFilter>
}

export type QueryAllNotificationMessageArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<NotificationMessageSorting>>
  where?: InputMaybe<NotificationMessageFilter>
}

export type QueryAllPageArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<PageSorting>>
  where?: InputMaybe<PageFilter>
}

export type QueryAllParentProductArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ParentProductSorting>>
  where?: InputMaybe<ParentProductFilter>
}

export type QueryAllPatientBrochureArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<PatientBrochureSorting>>
  where?: InputMaybe<PatientBrochureFilter>
}

export type QueryAllPatientEducationArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<PatientEducationSorting>>
  where?: InputMaybe<PatientEducationFilter>
}

export type QueryAllPharmacyContentArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<PharmacyContentSorting>>
  where?: InputMaybe<PharmacyContentFilter>
}

export type QueryAllPharmacyLibraryResourcesArgs = {
  filters?: InputMaybe<PharmacyResourceFilters>
  pagination?: InputMaybe<ResourcesPagination>
  sort?: InputMaybe<ResourcesSort>
}

export type QueryAllPriceListArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<PriceListSorting>>
  where?: InputMaybe<PriceListFilter>
}

export type QueryAllPrivateLabelFormArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<PrivateLabelFormSorting>>
  where?: InputMaybe<PrivateLabelFormFilter>
}

export type QueryAllProductArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ProductSorting>>
  where?: InputMaybe<ProductFilter>
}

export type QueryAllProductReferenceChartArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ProductReferenceChartSorting>>
  where?: InputMaybe<ProductReferenceChartFilter>
}

export type QueryAllProfessionalLibraryResourcesArgs = {
  filters?: InputMaybe<ProfessionalResourceFilters>
  pagination?: InputMaybe<ResourcesPagination>
  sort?: InputMaybe<ResourcesSort>
}

export type QueryAllProtocolArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ProtocolSorting>>
  where?: InputMaybe<ProtocolFilter>
}

export type QueryAllPublicLibraryResourcesArgs = {
  filters?: InputMaybe<PublicResourceFilters>
  pagination?: InputMaybe<ResourcesPagination>
  sort?: InputMaybe<ResourcesSort>
}

export type QueryAllResearchArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ResearchSorting>>
  where?: InputMaybe<ResearchFilter>
}

export type QueryAllResearchCategoryArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ResearchCategorySorting>>
  where?: InputMaybe<ResearchCategoryFilter>
}

export type QueryAllSanityFileAssetArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<SanityFileAssetSorting>>
  where?: InputMaybe<SanityFileAssetFilter>
}

export type QueryAllSanityImageAssetArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<SanityImageAssetSorting>>
  where?: InputMaybe<SanityImageAssetFilter>
}

export type QueryAllShippingCountryArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<ShippingCountrySorting>>
  where?: InputMaybe<ShippingCountryFilter>
}

export type QueryAllSiteColorArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<SiteColorSorting>>
  where?: InputMaybe<SiteColorFilter>
}

export type QueryAllSiteSettingsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<SiteSettingsSorting>>
  where?: InputMaybe<SiteSettingsFilter>
}

export type QueryAllSocialMediaResourceArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<SocialMediaResourceSorting>>
  where?: InputMaybe<SocialMediaResourceFilter>
}

export type QueryAllTeamMemberLeadershipArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<TeamMemberLeadershipSorting>>
  where?: InputMaybe<TeamMemberLeadershipFilter>
}

export type QueryAllTeamMemberScienceArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<TeamMemberScienceSorting>>
  where?: InputMaybe<TeamMemberScienceFilter>
}

export type QueryAllTechSheetArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<TechSheetSorting>>
  where?: InputMaybe<TechSheetFilter>
}

export type QueryAllTechSheetFrenchArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<TechSheetFrenchSorting>>
  where?: InputMaybe<TechSheetFrenchFilter>
}

export type QueryAllTermsArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<TermsSorting>>
  where?: InputMaybe<TermsFilter>
}

export type QueryAllWebinarArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<WebinarSorting>>
  where?: InputMaybe<WebinarFilter>
}

export type QueryAllWhitePaperArgs = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
  sort?: InputMaybe<Array<WhitePaperSorting>>
  where?: InputMaybe<WhitePaperFilter>
}

export type QueryCasiSessionResourceArgs = {
  slug: Scalars['String']
}

export type QueryCountryArgs = {
  countryCode: Scalars['String']
}

export type QueryProtocolResourceArgs = {
  slug: Scalars['String']
}

export type QuerySocialMediaResourceResourceArgs = {
  slug: Scalars['String']
}

export type QueryWebinarResourceArgs = {
  slug: Scalars['String']
}

export type QuestionMenuEntry = {
  __typename?: 'QuestionMenuEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contextBasedContent?: Maybe<ContextBasedContent>
  link?: Maybe<Link>
  name?: Maybe<Scalars['String']>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type QuestionMenuEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  contextBasedContent?: InputMaybe<ContextBasedContentFilter>
  link?: InputMaybe<LinkFilter>
  name?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type QuestionMenuEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  contextBasedContent?: InputMaybe<ContextBasedContentSorting>
  link?: InputMaybe<LinkSorting>
  name?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type Region = {
  __typename?: 'Region'
  iso: Scalars['String']
  name: Scalars['String']
}

export type RegistrationLink = {
  __typename?: 'RegistrationLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Direct the customer to a specific registration form */
  customerType?: Maybe<Scalars['String']>
}

export type RegistrationLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  customerType?: InputMaybe<StringFilter>
}

export type RegistrationLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  customerType?: InputMaybe<SortOrder>
}

export type RegistrationPage = {
  __typename?: 'RegistrationPage'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type RegistrationPageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type RegistrationPageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type Research = Document & {
  __typename?: 'Research'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  bodyRaw?: Maybe<Scalars['JSON']>
  category?: Maybe<ResearchCategory>
  excerptRaw?: Maybe<Scalars['JSON']>
  headerImage?: Maybe<MainImage>
  headerRaw?: Maybe<Scalars['JSON']>
  /** For search engines. Will be added to /sitemap.xml */
  includeInSitemap?: Maybe<Scalars['Boolean']>
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>
  mainImage?: Maybe<MainImage>
  openGraphImage?: Maybe<Image>
  /** This can be used to schedule post for publishing */
  publishedAt?: Maybe<Scalars['DateTime']>
  roleBasedAccessControl?: Maybe<RoleBasedAccessControl>
  /** For auto-generated links to share the post on Facebook, Twitter, etc. (displayed as social media icons) */
  showSocialLinks?: Maybe<Scalars['Boolean']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type ResearchCategory = Document & {
  __typename?: 'ResearchCategory'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  description?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type ResearchCategoryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  description?: InputMaybe<StringFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type ResearchCategorySorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type ResearchFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  category?: InputMaybe<ResearchCategoryFilter>
  headerImage?: InputMaybe<MainImageFilter>
  includeInSitemap?: InputMaybe<BooleanFilter>
  mainImage?: InputMaybe<MainImageFilter>
  openGraphImage?: InputMaybe<ImageFilter>
  publishedAt?: InputMaybe<DatetimeFilter>
  roleBasedAccessControl?: InputMaybe<RoleBasedAccessControlFilter>
  showSocialLinks?: InputMaybe<BooleanFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type ResearchSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  headerImage?: InputMaybe<MainImageSorting>
  includeInSitemap?: InputMaybe<SortOrder>
  mainImage?: InputMaybe<MainImageSorting>
  openGraphImage?: InputMaybe<ImageSorting>
  publishedAt?: InputMaybe<SortOrder>
  roleBasedAccessControl?: InputMaybe<RoleBasedAccessControlSorting>
  showSocialLinks?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type ResourceCommonFields = {
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export const ResourcesFilterNameRange = {
  AtoF: 'AtoF',
  GtoM: 'GtoM',
  NtoZ: 'NtoZ',
} as const

export type ResourcesFilterNameRange =
  (typeof ResourcesFilterNameRange)[keyof typeof ResourcesFilterNameRange]
export type ResourcesMenuEntry = {
  __typename?: 'ResourcesMenuEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contextBasedContent?: Maybe<ContextBasedContent>
  link?: Maybe<Link>
  name?: Maybe<Scalars['String']>
  roleBasedContent?: Maybe<RoleBasedContent>
}

export type ResourcesMenuEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  contextBasedContent?: InputMaybe<ContextBasedContentFilter>
  link?: InputMaybe<LinkFilter>
  name?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
}

export type ResourcesMenuEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  contextBasedContent?: InputMaybe<ContextBasedContentSorting>
  link?: InputMaybe<LinkSorting>
  name?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type ResourcesPagination = {
  limit?: InputMaybe<Scalars['Int']>
  offset?: InputMaybe<Scalars['Int']>
}

export type ResourcesSort = {
  field?: InputMaybe<ResourcesSortField>
  order?: InputMaybe<ResourcesSortOrder>
}

export const ResourcesSortField = {
  Type: '_type',
  Title: 'title',
} as const

export type ResourcesSortField = (typeof ResourcesSortField)[keyof typeof ResourcesSortField]
export const ResourcesSortOrder = {
  Asc: 'asc',
  Desc: 'desc',
} as const

export type ResourcesSortOrder = (typeof ResourcesSortOrder)[keyof typeof ResourcesSortOrder]
export type RichArticle = {
  __typename?: 'RichArticle'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  content?: Maybe<Array<Maybe<CtaWithImageOrRichArticleDividerImageOrRichArticleTextSection>>>
}

export type RichArticleDividerImage = {
  __typename?: 'RichArticleDividerImage'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Important for SEO and accessiblity. */
  alt?: Maybe<Scalars['String']>
  asset?: Maybe<SanityImageAsset>
  caption?: Maybe<Scalars['String']>
  crop?: Maybe<SanityImageCrop>
  hotspot?: Maybe<SanityImageHotspot>
}

export type RichArticleDividerImageFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  alt?: InputMaybe<StringFilter>
  asset?: InputMaybe<SanityImageAssetFilter>
  caption?: InputMaybe<StringFilter>
  crop?: InputMaybe<SanityImageCropFilter>
  hotspot?: InputMaybe<SanityImageHotspotFilter>
}

export type RichArticleDividerImageSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  alt?: InputMaybe<SortOrder>
  caption?: InputMaybe<SortOrder>
  crop?: InputMaybe<SanityImageCropSorting>
  hotspot?: InputMaybe<SanityImageHotspotSorting>
}

export type RichArticleFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type RichArticleSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type RichArticleTextSection = {
  __typename?: 'RichArticleTextSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  content?: Maybe<Scalars['String']>
}

export type RichArticleTextSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  content?: InputMaybe<StringFilter>
}

export type RichArticleTextSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  content?: InputMaybe<SortOrder>
}

export type RoleBasedAccessControl = {
  __typename?: 'RoleBasedAccessControl'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Toggle access control based on role */
  enabled?: Maybe<Scalars['Boolean']>
  roles?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type RoleBasedAccessControlFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  enabled?: InputMaybe<BooleanFilter>
}

export type RoleBasedAccessControlSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  enabled?: InputMaybe<SortOrder>
}

export type RoleBasedContent = {
  __typename?: 'RoleBasedContent'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Toggle conditional content based on role */
  enabled?: Maybe<Scalars['Boolean']>
  roles?: Maybe<Array<Maybe<Scalars['String']>>>
}

export type RoleBasedContentFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  enabled?: InputMaybe<BooleanFilter>
}

export type RoleBasedContentSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  enabled?: InputMaybe<SortOrder>
}

export type SanityAssetSourceData = {
  __typename?: 'SanityAssetSourceData'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** The unique ID for the asset within the originating source so you can programatically find back to it */
  id?: Maybe<Scalars['String']>
  /** A canonical name for the source this asset is originating from */
  name?: Maybe<Scalars['String']>
  /** A URL to find more information about this asset in the originating source */
  url?: Maybe<Scalars['String']>
}

export type SanityAssetSourceDataFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  id?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type SanityAssetSourceDataSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  id?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  url?: InputMaybe<SortOrder>
}

export type SanityFileAsset = Document & {
  __typename?: 'SanityFileAsset'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  altText?: Maybe<Scalars['String']>
  assetId?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  extension?: Maybe<Scalars['String']>
  label?: Maybe<Scalars['String']>
  mimeType?: Maybe<Scalars['String']>
  originalFilename?: Maybe<Scalars['String']>
  path?: Maybe<Scalars['String']>
  sha1hash?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['Float']>
  source?: Maybe<SanityAssetSourceData>
  title?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type SanityFileAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  altText?: InputMaybe<StringFilter>
  assetId?: InputMaybe<StringFilter>
  description?: InputMaybe<StringFilter>
  extension?: InputMaybe<StringFilter>
  label?: InputMaybe<StringFilter>
  mimeType?: InputMaybe<StringFilter>
  originalFilename?: InputMaybe<StringFilter>
  path?: InputMaybe<StringFilter>
  sha1hash?: InputMaybe<StringFilter>
  size?: InputMaybe<FloatFilter>
  source?: InputMaybe<SanityAssetSourceDataFilter>
  title?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type SanityFileAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  altText?: InputMaybe<SortOrder>
  assetId?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  extension?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  mimeType?: InputMaybe<SortOrder>
  originalFilename?: InputMaybe<SortOrder>
  path?: InputMaybe<SortOrder>
  sha1hash?: InputMaybe<SortOrder>
  size?: InputMaybe<SortOrder>
  source?: InputMaybe<SanityAssetSourceDataSorting>
  title?: InputMaybe<SortOrder>
  url?: InputMaybe<SortOrder>
}

export type SanityImageAsset = Document & {
  __typename?: 'SanityImageAsset'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  altText?: Maybe<Scalars['String']>
  assetId?: Maybe<Scalars['String']>
  description?: Maybe<Scalars['String']>
  extension?: Maybe<Scalars['String']>
  label?: Maybe<Scalars['String']>
  metadata?: Maybe<SanityImageMetadata>
  mimeType?: Maybe<Scalars['String']>
  originalFilename?: Maybe<Scalars['String']>
  path?: Maybe<Scalars['String']>
  sha1hash?: Maybe<Scalars['String']>
  size?: Maybe<Scalars['Float']>
  source?: Maybe<SanityAssetSourceData>
  title?: Maybe<Scalars['String']>
  uploadId?: Maybe<Scalars['String']>
  url?: Maybe<Scalars['String']>
}

export type SanityImageAssetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  altText?: InputMaybe<StringFilter>
  assetId?: InputMaybe<StringFilter>
  description?: InputMaybe<StringFilter>
  extension?: InputMaybe<StringFilter>
  label?: InputMaybe<StringFilter>
  metadata?: InputMaybe<SanityImageMetadataFilter>
  mimeType?: InputMaybe<StringFilter>
  originalFilename?: InputMaybe<StringFilter>
  path?: InputMaybe<StringFilter>
  sha1hash?: InputMaybe<StringFilter>
  size?: InputMaybe<FloatFilter>
  source?: InputMaybe<SanityAssetSourceDataFilter>
  title?: InputMaybe<StringFilter>
  uploadId?: InputMaybe<StringFilter>
  url?: InputMaybe<StringFilter>
}

export type SanityImageAssetSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  altText?: InputMaybe<SortOrder>
  assetId?: InputMaybe<SortOrder>
  description?: InputMaybe<SortOrder>
  extension?: InputMaybe<SortOrder>
  label?: InputMaybe<SortOrder>
  metadata?: InputMaybe<SanityImageMetadataSorting>
  mimeType?: InputMaybe<SortOrder>
  originalFilename?: InputMaybe<SortOrder>
  path?: InputMaybe<SortOrder>
  sha1hash?: InputMaybe<SortOrder>
  size?: InputMaybe<SortOrder>
  source?: InputMaybe<SanityAssetSourceDataSorting>
  title?: InputMaybe<SortOrder>
  uploadId?: InputMaybe<SortOrder>
  url?: InputMaybe<SortOrder>
}

export type SanityImageCrop = {
  __typename?: 'SanityImageCrop'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  bottom?: Maybe<Scalars['Float']>
  left?: Maybe<Scalars['Float']>
  right?: Maybe<Scalars['Float']>
  top?: Maybe<Scalars['Float']>
}

export type SanityImageCropFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  bottom?: InputMaybe<FloatFilter>
  left?: InputMaybe<FloatFilter>
  right?: InputMaybe<FloatFilter>
  top?: InputMaybe<FloatFilter>
}

export type SanityImageCropSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  bottom?: InputMaybe<SortOrder>
  left?: InputMaybe<SortOrder>
  right?: InputMaybe<SortOrder>
  top?: InputMaybe<SortOrder>
}

export type SanityImageDimensions = {
  __typename?: 'SanityImageDimensions'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  aspectRatio?: Maybe<Scalars['Float']>
  height?: Maybe<Scalars['Float']>
  width?: Maybe<Scalars['Float']>
}

export type SanityImageDimensionsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  aspectRatio?: InputMaybe<FloatFilter>
  height?: InputMaybe<FloatFilter>
  width?: InputMaybe<FloatFilter>
}

export type SanityImageDimensionsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  aspectRatio?: InputMaybe<SortOrder>
  height?: InputMaybe<SortOrder>
  width?: InputMaybe<SortOrder>
}

export type SanityImageHotspot = {
  __typename?: 'SanityImageHotspot'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  height?: Maybe<Scalars['Float']>
  width?: Maybe<Scalars['Float']>
  x?: Maybe<Scalars['Float']>
  y?: Maybe<Scalars['Float']>
}

export type SanityImageHotspotFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  height?: InputMaybe<FloatFilter>
  width?: InputMaybe<FloatFilter>
  x?: InputMaybe<FloatFilter>
  y?: InputMaybe<FloatFilter>
}

export type SanityImageHotspotSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  height?: InputMaybe<SortOrder>
  width?: InputMaybe<SortOrder>
  x?: InputMaybe<SortOrder>
  y?: InputMaybe<SortOrder>
}

export type SanityImageMetadata = {
  __typename?: 'SanityImageMetadata'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  blurHash?: Maybe<Scalars['String']>
  dimensions?: Maybe<SanityImageDimensions>
  hasAlpha?: Maybe<Scalars['Boolean']>
  isOpaque?: Maybe<Scalars['Boolean']>
  location?: Maybe<Geopoint>
  lqip?: Maybe<Scalars['String']>
  palette?: Maybe<SanityImagePalette>
}

export type SanityImageMetadataFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  blurHash?: InputMaybe<StringFilter>
  dimensions?: InputMaybe<SanityImageDimensionsFilter>
  hasAlpha?: InputMaybe<BooleanFilter>
  isOpaque?: InputMaybe<BooleanFilter>
  location?: InputMaybe<GeopointFilter>
  lqip?: InputMaybe<StringFilter>
  palette?: InputMaybe<SanityImagePaletteFilter>
}

export type SanityImageMetadataSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  blurHash?: InputMaybe<SortOrder>
  dimensions?: InputMaybe<SanityImageDimensionsSorting>
  hasAlpha?: InputMaybe<SortOrder>
  isOpaque?: InputMaybe<SortOrder>
  location?: InputMaybe<GeopointSorting>
  lqip?: InputMaybe<SortOrder>
  palette?: InputMaybe<SanityImagePaletteSorting>
}

export type SanityImagePalette = {
  __typename?: 'SanityImagePalette'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  darkMuted?: Maybe<SanityImagePaletteSwatch>
  darkVibrant?: Maybe<SanityImagePaletteSwatch>
  dominant?: Maybe<SanityImagePaletteSwatch>
  lightMuted?: Maybe<SanityImagePaletteSwatch>
  lightVibrant?: Maybe<SanityImagePaletteSwatch>
  muted?: Maybe<SanityImagePaletteSwatch>
  vibrant?: Maybe<SanityImagePaletteSwatch>
}

export type SanityImagePaletteFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  darkMuted?: InputMaybe<SanityImagePaletteSwatchFilter>
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>
  dominant?: InputMaybe<SanityImagePaletteSwatchFilter>
  lightMuted?: InputMaybe<SanityImagePaletteSwatchFilter>
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchFilter>
  muted?: InputMaybe<SanityImagePaletteSwatchFilter>
  vibrant?: InputMaybe<SanityImagePaletteSwatchFilter>
}

export type SanityImagePaletteSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  darkMuted?: InputMaybe<SanityImagePaletteSwatchSorting>
  darkVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>
  dominant?: InputMaybe<SanityImagePaletteSwatchSorting>
  lightMuted?: InputMaybe<SanityImagePaletteSwatchSorting>
  lightVibrant?: InputMaybe<SanityImagePaletteSwatchSorting>
  muted?: InputMaybe<SanityImagePaletteSwatchSorting>
  vibrant?: InputMaybe<SanityImagePaletteSwatchSorting>
}

export type SanityImagePaletteSwatch = {
  __typename?: 'SanityImagePaletteSwatch'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  background?: Maybe<Scalars['String']>
  foreground?: Maybe<Scalars['String']>
  population?: Maybe<Scalars['Float']>
  title?: Maybe<Scalars['String']>
}

export type SanityImagePaletteSwatchFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  background?: InputMaybe<StringFilter>
  foreground?: InputMaybe<StringFilter>
  population?: InputMaybe<FloatFilter>
  title?: InputMaybe<StringFilter>
}

export type SanityImagePaletteSwatchSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  background?: InputMaybe<SortOrder>
  foreground?: InputMaybe<SortOrder>
  population?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type Sanity_DocumentFilter = {
  /** All documents that are drafts. */
  is_draft?: InputMaybe<Scalars['Boolean']>
  /** All documents referencing the given document ID. */
  references?: InputMaybe<Scalars['ID']>
}

export type ScienceTeamGrid = {
  __typename?: 'ScienceTeamGrid'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  members?: Maybe<Array<Maybe<TeamMemberScience>>>
}

export type ScienceTeamGridFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type ScienceTeamGridSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type ShippingCountry = Document & {
  __typename?: 'ShippingCountry'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  country?: Maybe<Scalars['String']>
  isShippingRestricted?: Maybe<Scalars['Boolean']>
  shippingRegions?: Maybe<
    Array<
      Maybe<ShippingRegionAuOrShippingRegionCaOrShippingRegionChOrShippingRegionCnOrShippingRegionGbOrShippingRegionNzOrShippingRegionSgOrShippingRegionUs>
    >
  >
}

export type ShippingCountryFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  country?: InputMaybe<StringFilter>
  isShippingRestricted?: InputMaybe<BooleanFilter>
}

export type ShippingCountrySorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  country?: InputMaybe<SortOrder>
  isShippingRestricted?: InputMaybe<SortOrder>
}

export type ShippingRegionAu = {
  __typename?: 'ShippingRegionAu'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionAuFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionAuOrShippingRegionCaOrShippingRegionChOrShippingRegionCnOrShippingRegionGbOrShippingRegionNzOrShippingRegionSgOrShippingRegionUs =

    | ShippingRegionAu
    | ShippingRegionCa
    | ShippingRegionCh
    | ShippingRegionCn
    | ShippingRegionGb
    | ShippingRegionNz
    | ShippingRegionSg
    | ShippingRegionUs

export type ShippingRegionAuSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionCa = {
  __typename?: 'ShippingRegionCa'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionCaFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionCaSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionCh = {
  __typename?: 'ShippingRegionCh'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionChFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionChSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionCn = {
  __typename?: 'ShippingRegionCn'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionCnFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionCnSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionGb = {
  __typename?: 'ShippingRegionGb'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionGbFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionGbSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionNz = {
  __typename?: 'ShippingRegionNz'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionNzFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionNzSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionSg = {
  __typename?: 'ShippingRegionSg'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionSgFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionSgSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingRegionUs = {
  __typename?: 'ShippingRegionUs'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  isProductsRestrictedForAllRegions?: Maybe<Scalars['Boolean']>
  region?: Maybe<Scalars['String']>
  restrictedProducts?: Maybe<Array<Maybe<Product>>>
}

export type ShippingRegionUsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  isProductsRestrictedForAllRegions?: InputMaybe<BooleanFilter>
  region?: InputMaybe<StringFilter>
}

export type ShippingRegionUsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  isProductsRestrictedForAllRegions?: InputMaybe<SortOrder>
  region?: InputMaybe<SortOrder>
}

export type ShippingTooltips = {
  __typename?: 'ShippingTooltips'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  expeditedPatient?: Maybe<Scalars['String']>
  expeditedProfessional?: Maybe<Scalars['String']>
  standardPatient?: Maybe<Scalars['String']>
  standardProfessional?: Maybe<Scalars['String']>
}

export type ShippingTooltipsFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  expeditedPatient?: InputMaybe<StringFilter>
  expeditedProfessional?: InputMaybe<StringFilter>
  standardPatient?: InputMaybe<StringFilter>
  standardProfessional?: InputMaybe<StringFilter>
}

export type ShippingTooltipsSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  expeditedPatient?: InputMaybe<SortOrder>
  expeditedProfessional?: InputMaybe<SortOrder>
  standardPatient?: InputMaybe<SortOrder>
  standardProfessional?: InputMaybe<SortOrder>
}

export type SiteColor = Document & {
  __typename?: 'SiteColor'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  /** Hexadecimal code used to determine the color. */
  color?: Maybe<Scalars['String']>
  title?: Maybe<Scalars['String']>
}

export type SiteColorFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  color?: InputMaybe<StringFilter>
  title?: InputMaybe<StringFilter>
}

export type SiteColorSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  color?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type SiteSettings = Document & {
  __typename?: 'SiteSettings'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  acceptedCreditCards?: Maybe<CreditCardFlags>
  /** Toast message displayed when a blocked user attempts to log in */
  blockedUserErrorMessage?: Maybe<Scalars['String']>
  checkoutHelpTextRaw?: Maybe<Scalars['JSON']>
  commissionsOptOutForm?: Maybe<CustomerFormEntry>
  datasheetDisclaimer?: Maybe<Array<Maybe<BasicTextSection>>>
  /** Choose default HeroTag to use when not specified */
  defaultHeroTag?: Maybe<HeroTag>
  /** Description for search engines and social media */
  description?: Maybe<Scalars['String']>
  dispensaryBannerTextDisclaimerRaw?: Maybe<Scalars['JSON']>
  /** Choose a page to be the frontpage for users on a dispensary */
  dispensaryFrontpage?: Maybe<Page>
  dispensaryUpdateCartErrorMessageRaw?: Maybe<Scalars['JSON']>
  eftForm?: Maybe<CustomerFormEntry>
  footerCompanyMenu?: Maybe<Array<Maybe<CompanyMenuEntry>>>
  footerHelpMenu?: Maybe<Array<Maybe<HelpMenuEntry>>>
  footerLegalFootnotes?: Maybe<Array<Maybe<Scalars['String']>>>
  footerLegalMenu?: Maybe<Array<Maybe<MenuEntry>>>
  footerQuestionMenu?: Maybe<Array<Maybe<QuestionMenuEntry>>>
  footerResourcesMenu?: Maybe<Array<Maybe<ResourcesMenuEntry>>>
  footerSocialMenu?: Maybe<Array<Maybe<SocialMenuEntry>>>
  freeShippingThresholds?: Maybe<FreeShippingThresholds>
  /** Choose a page to be the frontpage */
  frontpage?: Maybe<Page>
  helpCenterMenu?: Maybe<Array<Maybe<HelpCenterMenuEntry>>>
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>
  /** Should be a valid bcp47 language code like en, en-US, no or nb-NO */
  lang?: Maybe<Scalars['String']>
  mainLogo?: Maybe<Image>
  mainMenu?: Maybe<Array<Maybe<MenuEntry>>>
  mobileMenu?: Maybe<Array<Maybe<MenuEntry>>>
  noSearchResultsFound?: Maybe<NoSearchResultsFound>
  onboardingPatientSpotlight?: Maybe<OnboardingPromotion>
  returnPolicyTextRaw?: Maybe<Scalars['JSON']>
  returnsHelpTextRaw?: Maybe<Scalars['JSON']>
  shippingTooltips?: Maybe<ShippingTooltips>
  taxIdFormV2?: Maybe<CustomerFormEntry>
  title?: Maybe<Scalars['String']>
  top25Drugs?: Maybe<Array<Maybe<Drug>>>
  utilityMenu?: Maybe<Array<Maybe<MenuEntry>>>
}

export type SiteSettingsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  acceptedCreditCards?: InputMaybe<CreditCardFlagsFilter>
  blockedUserErrorMessage?: InputMaybe<StringFilter>
  commissionsOptOutForm?: InputMaybe<CustomerFormEntryFilter>
  defaultHeroTag?: InputMaybe<HeroTagFilter>
  description?: InputMaybe<StringFilter>
  dispensaryFrontpage?: InputMaybe<PageFilter>
  eftForm?: InputMaybe<CustomerFormEntryFilter>
  freeShippingThresholds?: InputMaybe<FreeShippingThresholdsFilter>
  frontpage?: InputMaybe<PageFilter>
  lang?: InputMaybe<StringFilter>
  mainLogo?: InputMaybe<ImageFilter>
  noSearchResultsFound?: InputMaybe<NoSearchResultsFoundFilter>
  onboardingPatientSpotlight?: InputMaybe<OnboardingPromotionFilter>
  shippingTooltips?: InputMaybe<ShippingTooltipsFilter>
  taxIdFormV2?: InputMaybe<CustomerFormEntryFilter>
  title?: InputMaybe<StringFilter>
}

export type SiteSettingsSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  acceptedCreditCards?: InputMaybe<CreditCardFlagsSorting>
  blockedUserErrorMessage?: InputMaybe<SortOrder>
  commissionsOptOutForm?: InputMaybe<CustomerFormEntrySorting>
  description?: InputMaybe<SortOrder>
  eftForm?: InputMaybe<CustomerFormEntrySorting>
  freeShippingThresholds?: InputMaybe<FreeShippingThresholdsSorting>
  lang?: InputMaybe<SortOrder>
  mainLogo?: InputMaybe<ImageSorting>
  noSearchResultsFound?: InputMaybe<NoSearchResultsFoundSorting>
  onboardingPatientSpotlight?: InputMaybe<OnboardingPromotionSorting>
  shippingTooltips?: InputMaybe<ShippingTooltipsSorting>
  taxIdFormV2?: InputMaybe<CustomerFormEntrySorting>
  title?: InputMaybe<SortOrder>
}

export type Slug = {
  __typename?: 'Slug'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  current?: Maybe<Scalars['String']>
}

export type SlugFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  current?: InputMaybe<StringFilter>
}

export type SlugSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  current?: InputMaybe<SortOrder>
}

export type Snp = {
  __typename?: 'Snp'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  effect?: Maybe<Scalars['String']>
  effectAlleles?: Maybe<Scalars['String']>
  gene?: Maybe<Scalars['String']>
  genomicReferences?: Maybe<Scalars['String']>
  isGenomicSpotlight?: Maybe<Scalars['Boolean']>
  notation?: Maybe<Scalars['String']>
  snp?: Maybe<Scalars['String']>
}

export type SnpFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  effect?: InputMaybe<StringFilter>
  effectAlleles?: InputMaybe<StringFilter>
  gene?: InputMaybe<StringFilter>
  genomicReferences?: InputMaybe<StringFilter>
  isGenomicSpotlight?: InputMaybe<BooleanFilter>
  notation?: InputMaybe<StringFilter>
  snp?: InputMaybe<StringFilter>
}

export type SnpSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  effect?: InputMaybe<SortOrder>
  effectAlleles?: InputMaybe<SortOrder>
  gene?: InputMaybe<SortOrder>
  genomicReferences?: InputMaybe<SortOrder>
  isGenomicSpotlight?: InputMaybe<SortOrder>
  notation?: InputMaybe<SortOrder>
  snp?: InputMaybe<SortOrder>
}

export type SocialMediaResource = Document & {
  __typename?: 'SocialMediaResource'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<Image>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type SocialMediaResourceFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<ImageFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type SocialMediaResourceResource = ResourceCommonFields & {
  __typename?: 'SocialMediaResourceResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  asset?: Maybe<ImageResource>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type SocialMediaResourceSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<ImageSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type SocialMenuEntry = {
  __typename?: 'SocialMenuEntry'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  icon?: Maybe<Scalars['String']>
  link?: Maybe<ExternalLink>
  name?: Maybe<Scalars['String']>
}

export type SocialMenuEntryFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  icon?: InputMaybe<StringFilter>
  link?: InputMaybe<ExternalLinkFilter>
  name?: InputMaybe<StringFilter>
}

export type SocialMenuEntrySorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  icon?: InputMaybe<SortOrder>
  link?: InputMaybe<ExternalLinkSorting>
  name?: InputMaybe<SortOrder>
}

export const SortOrder = {
  /** Sorts on the value in ascending order. */
  Asc: 'ASC',
  /** Sorts on the value in descending order. */
  Desc: 'DESC',
} as const

export type SortOrder = (typeof SortOrder)[keyof typeof SortOrder]
export type SpacerSection = {
  __typename?: 'SpacerSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  backgroundStyles?: Maybe<BackgroundStyles>
  size?: Maybe<Scalars['String']>
}

export type SpacerSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  backgroundStyles?: InputMaybe<BackgroundStylesFilter>
  size?: InputMaybe<StringFilter>
}

export type SpacerSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  backgroundStyles?: InputMaybe<BackgroundStylesSorting>
  size?: InputMaybe<SortOrder>
}

export type Span = {
  __typename?: 'Span'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  marks?: Maybe<Array<Maybe<Scalars['String']>>>
  text?: Maybe<Scalars['String']>
}

export type SpotlightProduct = {
  __typename?: 'SpotlightProduct'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  cta?: Maybe<Cta>
  productDescription?: Maybe<Scalars['String']>
  productImage?: Maybe<Image>
  productTitle?: Maybe<Scalars['String']>
}

export type SpotlightProductFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  cta?: InputMaybe<CtaFilter>
  productDescription?: InputMaybe<StringFilter>
  productImage?: InputMaybe<ImageFilter>
  productTitle?: InputMaybe<StringFilter>
}

export type SpotlightProductSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  cta?: InputMaybe<CtaSorting>
  productDescription?: InputMaybe<SortOrder>
  productImage?: InputMaybe<ImageSorting>
  productTitle?: InputMaybe<SortOrder>
}

export type StringFilter = {
  /** Checks if the value is equal to the given input. */
  eq?: InputMaybe<Scalars['String']>
  in?: InputMaybe<Array<Scalars['String']>>
  /** Checks if the value matches the given word/words. */
  matches?: InputMaybe<Scalars['String']>
  /** Checks if the value is not equal to the given input. */
  neq?: InputMaybe<Scalars['String']>
  nin?: InputMaybe<Array<Scalars['String']>>
}

export type SupportRequestLink = {
  __typename?: 'SupportRequestLink'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  /** Placeholder property since at least one field is required */
  placeholder?: Maybe<Scalars['String']>
}

export type SupportRequestLinkFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  placeholder?: InputMaybe<StringFilter>
}

export type SupportRequestLinkSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  placeholder?: InputMaybe<SortOrder>
}

export type Table = {
  __typename?: 'Table'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  rows?: Maybe<Array<Maybe<TableRow>>>
}

export type TableCell = {
  __typename?: 'TableCell'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  colSpan?: Maybe<Scalars['Float']>
  data?: Maybe<TableCellData>
  rowSpan?: Maybe<Scalars['Float']>
}

export type TableCellData = {
  __typename?: 'TableCellData'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  contentsRaw?: Maybe<Scalars['JSON']>
  heading?: Maybe<Scalars['Boolean']>
}

export type TableCellDataFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  heading?: InputMaybe<BooleanFilter>
}

export type TableCellDataSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  heading?: InputMaybe<SortOrder>
}

export type TableCellFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  colSpan?: InputMaybe<FloatFilter>
  data?: InputMaybe<TableCellDataFilter>
  rowSpan?: InputMaybe<FloatFilter>
}

export type TableCellSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  colSpan?: InputMaybe<SortOrder>
  data?: InputMaybe<TableCellDataSorting>
  rowSpan?: InputMaybe<SortOrder>
}

export type TableFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type TableRow = {
  __typename?: 'TableRow'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  cells?: Maybe<Array<Maybe<TableCell>>>
}

export type TableRowFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
}

export type TableRowSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type TableSection = {
  __typename?: 'TableSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  table?: Maybe<Table>
  title?: Maybe<Scalars['String']>
}

export type TableSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  table?: InputMaybe<TableFilter>
  title?: InputMaybe<StringFilter>
}

export type TableSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  table?: InputMaybe<TableSorting>
  title?: InputMaybe<SortOrder>
}

export type TableSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
}

export type TeamMemberLeadership = Document & {
  __typename?: 'TeamMemberLeadership'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  biographyRaw?: Maybe<Scalars['JSON']>
  /** Comma separated list of professional designations */
  degrees?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  photo?: Maybe<Image>
  /** Team member's title within organization */
  title?: Maybe<Scalars['String']>
}

export type TeamMemberLeadershipFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  degrees?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  photo?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
}

export type TeamMemberLeadershipSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  degrees?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  photo?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type TeamMemberScience = Document & {
  __typename?: 'TeamMemberScience'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  biographyRaw?: Maybe<Scalars['JSON']>
  /** Comma separated list of professional designations */
  degrees?: Maybe<Scalars['String']>
  name?: Maybe<Scalars['String']>
  photo?: Maybe<Image>
  /** Team member's title within organization */
  title?: Maybe<Scalars['String']>
}

export type TeamMemberScienceFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  degrees?: InputMaybe<StringFilter>
  name?: InputMaybe<StringFilter>
  photo?: InputMaybe<ImageFilter>
  title?: InputMaybe<StringFilter>
}

export type TeamMemberScienceSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  degrees?: InputMaybe<SortOrder>
  name?: InputMaybe<SortOrder>
  photo?: InputMaybe<ImageSorting>
  title?: InputMaybe<SortOrder>
}

export type TechSheet = Document & {
  __typename?: 'TechSheet'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type TechSheetFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type TechSheetFrench = Document & {
  __typename?: 'TechSheetFrench'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type TechSheetFrenchFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type TechSheetFrenchResource = ResourceCommonFields & {
  __typename?: 'TechSheetFrenchResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type TechSheetFrenchSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type TechSheetResource = ResourceCommonFields & {
  __typename?: 'TechSheetResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type TechSheetSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type Terms = Document & {
  __typename?: 'Terms'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  contentRaw?: Maybe<Scalars['JSON']>
  identifier?: Maybe<Scalars['String']>
  lastModified?: Maybe<Scalars['Date']>
  title?: Maybe<Scalars['String']>
}

export type TermsFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  identifier?: InputMaybe<StringFilter>
  lastModified?: InputMaybe<DateFilter>
  title?: InputMaybe<StringFilter>
}

export type TermsSection = {
  __typename?: 'TermsSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  roleBasedContent?: Maybe<RoleBasedContent>
  terms?: Maybe<Terms>
}

export type TermsSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  terms?: InputMaybe<TermsFilter>
}

export type TermsSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
}

export type TermsSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  identifier?: InputMaybe<SortOrder>
  lastModified?: InputMaybe<SortOrder>
  title?: InputMaybe<SortOrder>
}

export type TextStyles = {
  __typename?: 'TextStyles'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  headerColor?: Maybe<SiteColor>
  textAlign?: Maybe<Scalars['String']>
  /** Hexadecimal code used to determine the text color. */
  textColor?: Maybe<Scalars['String']>
  /** Select text color from list of site colors. */
  textColorV2?: Maybe<SiteColor>
}

export type TextStylesFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  headerColor?: InputMaybe<SiteColorFilter>
  textAlign?: InputMaybe<StringFilter>
  textColor?: InputMaybe<StringFilter>
  textColorV2?: InputMaybe<SiteColorFilter>
}

export type TextStylesSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  textAlign?: InputMaybe<SortOrder>
  textColor?: InputMaybe<SortOrder>
}

export type VideoSection = {
  __typename?: 'VideoSection'
  _key?: Maybe<Scalars['String']>
  _type?: Maybe<Scalars['String']>
  pageSectionStyles?: Maybe<PageSectionStyles>
  roleBasedContent?: Maybe<RoleBasedContent>
  textStyles?: Maybe<TextStyles>
  title?: Maybe<Scalars['String']>
  wistiaShareUrl?: Maybe<Scalars['String']>
}

export type VideoSectionFilter = {
  _key?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  pageSectionStyles?: InputMaybe<PageSectionStylesFilter>
  roleBasedContent?: InputMaybe<RoleBasedContentFilter>
  textStyles?: InputMaybe<TextStylesFilter>
  title?: InputMaybe<StringFilter>
  wistiaShareUrl?: InputMaybe<StringFilter>
}

export type VideoSectionSorting = {
  _key?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  pageSectionStyles?: InputMaybe<PageSectionStylesSorting>
  roleBasedContent?: InputMaybe<RoleBasedContentSorting>
  textStyles?: InputMaybe<TextStylesSorting>
  title?: InputMaybe<SortOrder>
  wistiaShareUrl?: InputMaybe<SortOrder>
}

export type Webinar = Document & {
  __typename?: 'Webinar'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
  wistiaShareUrl?: Maybe<Scalars['String']>
}

export type WebinarFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
  wistiaShareUrl?: InputMaybe<StringFilter>
}

export type WebinarResource = ResourceCommonFields & {
  __typename?: 'WebinarResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
  wistiaShareUrl?: Maybe<Scalars['String']>
}

export type WebinarSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
  wistiaShareUrl?: InputMaybe<SortOrder>
}

export type WhitePaper = Document & {
  __typename?: 'WhitePaper'
  /** Date the document was created */
  _createdAt?: Maybe<Scalars['DateTime']>
  /** Document ID */
  _id?: Maybe<Scalars['ID']>
  _key?: Maybe<Scalars['String']>
  /** Current document revision */
  _rev?: Maybe<Scalars['String']>
  /** Document type */
  _type?: Maybe<Scalars['String']>
  /** Date the document was last modified */
  _updatedAt?: Maybe<Scalars['DateTime']>
  asset?: Maybe<File>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type WhitePaperFilter = {
  /** Apply filters on document level */
  _?: InputMaybe<Sanity_DocumentFilter>
  _createdAt?: InputMaybe<DatetimeFilter>
  _id?: InputMaybe<IdFilter>
  _key?: InputMaybe<StringFilter>
  _rev?: InputMaybe<StringFilter>
  _type?: InputMaybe<StringFilter>
  _updatedAt?: InputMaybe<DatetimeFilter>
  asset?: InputMaybe<FileFilter>
  slug?: InputMaybe<SlugFilter>
  title?: InputMaybe<StringFilter>
}

export type WhitePaperResource = ResourceCommonFields & {
  __typename?: 'WhitePaperResource'
  _id?: Maybe<Scalars['ID']>
  _type?: Maybe<Scalars['String']>
  slug?: Maybe<Slug>
  title?: Maybe<Scalars['String']>
}

export type WhitePaperSorting = {
  _createdAt?: InputMaybe<SortOrder>
  _id?: InputMaybe<SortOrder>
  _key?: InputMaybe<SortOrder>
  _rev?: InputMaybe<SortOrder>
  _type?: InputMaybe<SortOrder>
  _updatedAt?: InputMaybe<SortOrder>
  asset?: InputMaybe<FileSorting>
  slug?: InputMaybe<SlugSorting>
  title?: InputMaybe<SortOrder>
}

export type GetCountriesQueryVariables = Exact<{ [key: string]: never }>

export type GetCountriesQuery = {
  __typename?: 'Query'
  allCountries: Array<{ __typename?: 'Country'; iso: string; name: string } | null>
}

export type GetCountryQueryVariables = Exact<{
  countryCode: Scalars['String']
}>

export type GetCountryQuery = {
  __typename?: 'Query'
  country?: {
    __typename?: 'Country'
    iso: string
    name: string
    regions: Array<{ __typename?: 'Region'; iso: string; name: string }>
  } | null
}

export type CasiSessionResourceQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type CasiSessionResourceQuery = {
  __typename?: 'Query'
  casiSessionResource?: {
    __typename?: 'CasiSessionResource'
    _id?: string | null
    _type?: string | null
    title?: string | null
    wistiaShareUrl?: string | null
    slug?: { __typename?: 'Slug'; current?: string | null } | null
  } | null
}

export type AllPharmacyLibraryResourcesQueryVariables = Exact<{
  pagination?: InputMaybe<ResourcesPagination>
  sort?: InputMaybe<ResourcesSort>
  filters?: InputMaybe<PharmacyResourceFilters>
}>

export type AllPharmacyLibraryResourcesQuery = {
  __typename?: 'Query'
  allPharmacyLibraryResources?: {
    __typename?: 'AllPharmacyLibraryResources'
    meta?: {
      __typename?: 'AllPharmacyLibraryMeta'
      count?: {
        __typename?: 'AllPharmacyLibraryMetaCount'
        all?: number | null
        casiSession?: number | null
        catalogTraining?: number | null
        categoryBrochure?: number | null
        journalArticle?: number | null
        literatureReference?: number | null
        patientBrochure?: number | null
        patientEducation?: number | null
        pharmacyContent?: number | null
        privateLabelForm?: number | null
        productReferenceChart?: number | null
        protocol?: number | null
        socialMediaResource?: number | null
        techSheet?: number | null
        techSheetFrench?: number | null
        priceList?: number | null
        whitePaper?: number | null
        webinar?: number | null
      } | null
      pagination?: {
        __typename?: 'AllLibraryMetaPagination'
        totalPages?: number | null
        currentPage?: number | null
        currentCount?: number | null
      } | null
    } | null
    resources?: Array<
      | {
          __typename?: 'CasiSessionResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'CatalogTrainingResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'CategoryBrochureResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'JournalArticleResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'LiteratureReferenceResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PatientBrochureResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PatientEducationResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PharmacyContentResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PriceListResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PrivateLabelFormResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'ProductReferenceChartResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'ProtocolResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'SocialMediaResourceResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
          asset?: {
            __typename?: 'ImageResource'
            _type?: string | null
            asset?: {
              __typename?: 'ImageResourceAsset'
              _id?: string | null
              _type?: string | null
              url?: string | null
            } | null
          } | null
        }
      | {
          __typename?: 'TechSheetFrenchResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'TechSheetResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'WebinarResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'WhitePaperResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type AllProfessionalLibraryResourcesQueryVariables = Exact<{
  pagination?: InputMaybe<ResourcesPagination>
  sort?: InputMaybe<ResourcesSort>
  filters?: InputMaybe<ProfessionalResourceFilters>
}>

export type AllProfessionalLibraryResourcesQuery = {
  __typename?: 'Query'
  allProfessionalLibraryResources?: {
    __typename?: 'AllProfessionalLibraryResources'
    meta?: {
      __typename?: 'AllProfessionalLibraryMeta'
      count?: {
        __typename?: 'AllProfessionalLibraryMetaCount'
        all?: number | null
        casiSession?: number | null
        catalogTraining?: number | null
        categoryBrochure?: number | null
        journalArticle?: number | null
        literatureReference?: number | null
        patientBrochure?: number | null
        patientEducation?: number | null
        privateLabelForm?: number | null
        productReferenceChart?: number | null
        protocol?: number | null
        socialMediaResource?: number | null
        techSheet?: number | null
        techSheetFrench?: number | null
        priceList?: number | null
        whitePaper?: number | null
        webinar?: number | null
      } | null
      pagination?: {
        __typename?: 'AllLibraryMetaPagination'
        totalPages?: number | null
        currentPage?: number | null
        currentCount?: number | null
      } | null
    } | null
    resources?: Array<
      | {
          __typename?: 'CasiSessionResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'CatalogTrainingResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'CategoryBrochureResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'JournalArticleResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'LiteratureReferenceResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PatientBrochureResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PatientEducationResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PriceListResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PrivateLabelFormResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'ProductReferenceChartResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'ProtocolResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'SocialMediaResourceResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
          asset?: {
            __typename?: 'ImageResource'
            _type?: string | null
            asset?: {
              __typename?: 'ImageResourceAsset'
              _id?: string | null
              _type?: string | null
              url?: string | null
            } | null
          } | null
        }
      | {
          __typename?: 'TechSheetFrenchResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'TechSheetResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'WebinarResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'WhitePaperResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type ProtocolResourceQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type ProtocolResourceQuery = {
  __typename?: 'Query'
  protocolResource?: {
    __typename?: 'ProtocolResource'
    _id?: string | null
    _type?: string | null
    title?: string | null
    bodyRaw?: any | null
    slug?: { __typename?: 'Slug'; current?: string | null } | null
    products?: Array<{
      __typename?: 'Product'
      quantity?: number | null
      product?: { __typename?: 'ProductReference'; sku?: string | null } | null
    } | null> | null
    productsAdjunct?: Array<{
      __typename?: 'Product'
      quantity?: number | null
      product?: { __typename?: 'ProductReference'; sku?: string | null } | null
    } | null> | null
  } | null
}

export type ProtocolsSearchQueryVariables = Exact<{
  searchKeyword: Scalars['String']
}>

export type ProtocolsSearchQuery = {
  __typename?: 'Query'
  allProfessionalLibraryResources?: {
    __typename?: 'AllProfessionalLibraryResources'
    meta?: {
      __typename?: 'AllProfessionalLibraryMeta'
      count?: {
        __typename?: 'AllProfessionalLibraryMetaCount'
        all?: number | null
        protocol?: number | null
      } | null
      pagination?: {
        __typename?: 'AllLibraryMetaPagination'
        totalPages?: number | null
        currentPage?: number | null
        currentCount?: number | null
      } | null
    } | null
    resources?: Array<
      | { __typename?: 'CasiSessionResource' }
      | { __typename?: 'CatalogTrainingResource' }
      | { __typename?: 'CategoryBrochureResource' }
      | { __typename?: 'JournalArticleResource' }
      | { __typename?: 'LiteratureReferenceResource' }
      | { __typename?: 'PatientBrochureResource' }
      | { __typename?: 'PatientEducationResource' }
      | { __typename?: 'PriceListResource' }
      | { __typename?: 'PrivateLabelFormResource' }
      | { __typename?: 'ProductReferenceChartResource' }
      | {
          __typename?: 'ProtocolResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          bodyRaw?: any | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
          products?: Array<{
            __typename?: 'Product'
            quantity?: number | null
            product?: { __typename?: 'ProductReference'; sku?: string | null } | null
          } | null> | null
          productsAdjunct?: Array<{
            __typename?: 'Product'
            quantity?: number | null
            product?: { __typename?: 'ProductReference'; sku?: string | null } | null
          } | null> | null
        }
      | { __typename?: 'SocialMediaResourceResource' }
      | { __typename?: 'TechSheetFrenchResource' }
      | { __typename?: 'TechSheetResource' }
      | { __typename?: 'WebinarResource' }
      | { __typename?: 'WhitePaperResource' }
      | null
    > | null
  } | null
}

export type AllPublicLibraryResourcesQueryVariables = Exact<{
  pagination?: InputMaybe<ResourcesPagination>
  sort?: InputMaybe<ResourcesSort>
  filters?: InputMaybe<PublicResourceFilters>
}>

export type AllPublicLibraryResourcesQuery = {
  __typename?: 'Query'
  allPublicLibraryResources?: {
    __typename?: 'AllPublicLibraryResources'
    meta?: {
      __typename?: 'AllPublicLibraryMeta'
      count?: {
        __typename?: 'AllPublicLibraryMetaCount'
        all?: number | null
        casiSession?: number | null
        patientBrochure?: number | null
        patientEducation?: number | null
      } | null
      pagination?: {
        __typename?: 'AllLibraryMetaPagination'
        totalPages?: number | null
        currentPage?: number | null
        currentCount?: number | null
      } | null
    } | null
    resources?: Array<
      | {
          __typename?: 'CasiSessionResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PatientBrochureResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | {
          __typename?: 'PatientEducationResource'
          _id?: string | null
          _type?: string | null
          title?: string | null
          slug?: { __typename?: 'Slug'; current?: string | null } | null
        }
      | null
    > | null
  } | null
}

export type SocialMediaResourceResourceQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type SocialMediaResourceResourceQuery = {
  __typename?: 'Query'
  socialMediaResourceResource?: {
    __typename?: 'SocialMediaResourceResource'
    _id?: string | null
    _type?: string | null
    title?: string | null
    slug?: { __typename?: 'Slug'; current?: string | null } | null
    asset?: {
      __typename?: 'ImageResource'
      _type?: string | null
      asset?: {
        __typename?: 'ImageResourceAsset'
        _id?: string | null
        _type?: string | null
        url?: string | null
      } | null
    } | null
  } | null
}

export type WebinarResourceQueryVariables = Exact<{
  slug: Scalars['String']
}>

export type WebinarResourceQuery = {
  __typename?: 'Query'
  webinarResource?: {
    __typename?: 'WebinarResource'
    _id?: string | null
    _type?: string | null
    title?: string | null
    wistiaShareUrl?: string | null
    slug?: { __typename?: 'Slug'; current?: string | null } | null
  } | null
}

export type PageQueryVariables = Exact<{
  id: Scalars['ID']
}>

export type PageQuery = {
  __typename?: 'Query'
  Page?: {
    __typename?: 'Page'
    _id?: string | null
    title?: string | null
    description?: string | null
    keywords?: Array<string | null> | null
    openGraphImage?: {
      __typename?: 'Image'
      asset?: { __typename?: 'SanityImageAsset'; assetId?: string | null } | null
    } | null
    content?: Array<
      | { __typename: 'BannerWithArticle' }
      | { __typename: 'BannerWithText' }
      | { __typename: 'BasicArticle' }
      | { __typename: 'BasicTextSection' }
      | { __typename: 'BlockMenu' }
      | { __typename: 'BlockMenuAdditionalShortcuts' }
      | { __typename: 'BlockMenuCta' }
      | { __typename: 'ButtonBlockSection' }
      | { __typename: 'Carousel' }
      | { __typename: 'CtaBlockSection' }
      | { __typename: 'CtaCardSection' }
      | { __typename: 'DispensaryBio' }
      | { __typename: 'DispensaryFeaturedProducts' }
      | { __typename: 'DispensaryHero' }
      | { __typename: 'FeaturedProductsBanner' }
      | { __typename: 'FeaturedProductsCarousel' }
      | { __typename: 'GlobalMarkets' }
      | { __typename: 'HubSpotForm' }
      | { __typename: 'IconAndTextGrid' }
      | { __typename: 'IconAndTextGridSmall' }
      | { __typename: 'ImageAndTextSection' }
      | { __typename: 'Instapage' }
      | { __typename: 'LeadershipGrid' }
      | { __typename: 'Library' }
      | { __typename: 'LogoDividerSection' }
      | { __typename: 'Notification' }
      | { __typename: 'PageHero' }
      | { __typename: 'ProductSpotlight' }
      | { __typename: 'RegistrationPage' }
      | { __typename: 'RichArticle' }
      | { __typename: 'ScienceTeamGrid' }
      | { __typename: 'SpacerSection' }
      | { __typename: 'TableSection' }
      | { __typename: 'TermsSection' }
      | { __typename: 'VideoSection' }
      | null
    > | null
  } | null
}

export type ProductProtocolsQueryVariables = Exact<{
  sku: Scalars['String']
}>

export type ProductProtocolsQuery = {
  __typename?: 'Query'
  allProduct: Array<{
    __typename?: 'Product'
    _id?: string | null
    _type?: string | null
    protocols?: Array<{
      __typename?: 'ProtocolResource'
      title?: string | null
      slug?: { __typename?: 'Slug'; current?: string | null } | null
    }> | null
  }>
}

export const GetCountriesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCountries' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allCountries' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iso' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCountriesQuery, GetCountriesQueryVariables>
export const GetCountryDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'getCountry' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'countryCode' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'country' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'countryCode' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'countryCode' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'iso' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'regions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'iso' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetCountryQuery, GetCountryQueryVariables>
export const CasiSessionResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'casiSessionResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'casiSessionResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'current' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wistiaShareUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<CasiSessionResourceQuery, CasiSessionResourceQueryVariables>
export const AllPharmacyLibraryResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allPharmacyLibraryResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourcesPagination' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourcesSort' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PharmacyResourceFilters' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPharmacyLibraryResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'count' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'all' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'casiSession' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'catalogTraining' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryBrochure' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'journalArticle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'literatureReference' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientBrochure' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientEducation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'pharmacyContent' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'privateLabelForm' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productReferenceChart' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'socialMediaResource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'techSheet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'techSheetFrench' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceList' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'whitePaper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webinar' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CasiSessionResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CatalogTrainingResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CategoryBrochureResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'JournalArticleResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'LiteratureReferenceResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PatientBrochureResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PatientEducationResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PrivateLabelFormResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ProductReferenceChartResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ProtocolResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SocialMediaResourceResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asset' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TechSheetResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TechSheetFrenchResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PriceListResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'WhitePaperResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'WebinarResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PharmacyContentResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllPharmacyLibraryResourcesQuery,
  AllPharmacyLibraryResourcesQueryVariables
>
export const AllProfessionalLibraryResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allProfessionalLibraryResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourcesPagination' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourcesSort' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ProfessionalResourceFilters' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allProfessionalLibraryResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'count' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'all' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'casiSession' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'catalogTraining' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'categoryBrochure' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'journalArticle' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'literatureReference' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientBrochure' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientEducation' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'privateLabelForm' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productReferenceChart' },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'socialMediaResource' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'techSheet' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'techSheetFrench' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'priceList' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'whitePaper' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'webinar' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CasiSessionResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CatalogTrainingResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CategoryBrochureResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'JournalArticleResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'LiteratureReferenceResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PatientBrochureResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PatientEducationResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PrivateLabelFormResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ProductReferenceChartResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ProtocolResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'SocialMediaResourceResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'asset' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'asset' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                                        { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                                        { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TechSheetResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'TechSheetFrenchResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PriceListResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'WhitePaperResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'WebinarResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllProfessionalLibraryResourcesQuery,
  AllProfessionalLibraryResourcesQueryVariables
>
export const ProtocolResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'protocolResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'protocolResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'current' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'bodyRaw' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'products' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sku' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'productsAdjunct' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'product' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'sku' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProtocolResourceQuery, ProtocolResourceQueryVariables>
export const ProtocolsSearchDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'protocolsSearch' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'searchKeyword' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allProfessionalLibraryResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'offset' },
                      value: { kind: 'IntValue', value: '0' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'limit' },
                      value: { kind: 'IntValue', value: '100' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'field' },
                      value: { kind: 'EnumValue', value: 'title' },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'order' },
                      value: { kind: 'EnumValue', value: 'asc' },
                    },
                  ],
                },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'type' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'protocol' }],
                      },
                    },
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'searchKeyword' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'searchKeyword' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'count' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'all' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'protocol' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'ProtocolResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                            { kind: 'Field', name: { kind: 'Name', value: 'bodyRaw' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'products' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'productsAdjunct' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'product' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        { kind: 'Field', name: { kind: 'Name', value: 'sku' } },
                                      ],
                                    },
                                  },
                                  { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProtocolsSearchQuery, ProtocolsSearchQueryVariables>
export const AllPublicLibraryResourcesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'allPublicLibraryResources' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourcesPagination' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'ResourcesSort' } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
          type: { kind: 'NamedType', name: { kind: 'Name', value: 'PublicResourceFilters' } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allPublicLibraryResources' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'pagination' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'pagination' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'sort' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'sort' } },
              },
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'filters' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'filters' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'meta' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'count' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'all' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'casiSession' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientBrochure' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'patientEducation' } },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pagination' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'totalPages' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentPage' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currentCount' } },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'resources' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'CasiSessionResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PatientBrochureResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'InlineFragment',
                        typeCondition: {
                          kind: 'NamedType',
                          name: { kind: 'Name', value: 'PatientEducationResource' },
                        },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'slug' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  { kind: 'Field', name: { kind: 'Name', value: 'current' } },
                                ],
                              },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  AllPublicLibraryResourcesQuery,
  AllPublicLibraryResourcesQueryVariables
>
export const SocialMediaResourceResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'socialMediaResourceResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'socialMediaResourceResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'current' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'asset' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                            { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  SocialMediaResourceResourceQuery,
  SocialMediaResourceResourceQueryVariables
>
export const WebinarResourceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'webinarResource' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'webinarResource' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'slug' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'slug' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'slug' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: 'current' } }],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'wistiaShareUrl' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<WebinarResourceQuery, WebinarResourceQueryVariables>
export const PageDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'page' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'Page' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: { kind: 'Variable', name: { kind: 'Name', value: 'id' } },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                { kind: 'Field', name: { kind: 'Name', value: 'keywords' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'openGraphImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'asset' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'assetId' } }],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'content' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'Field', name: { kind: 'Name', value: '__typename' } }],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<PageQuery, PageQueryVariables>
export const ProductProtocolsDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'productProtocols' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
          type: {
            kind: 'NonNullType',
            type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'allProduct' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'where' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'sku' },
                      value: {
                        kind: 'ObjectValue',
                        fields: [
                          {
                            kind: 'ObjectField',
                            name: { kind: 'Name', value: 'eq' },
                            value: { kind: 'Variable', name: { kind: 'Name', value: 'sku' } },
                          },
                        ],
                      },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '_id' } },
                { kind: 'Field', name: { kind: 'Name', value: '_type' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'protocols' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'slug' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'current' } }],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ProductProtocolsQuery, ProductProtocolsQueryVariables>
